<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">商品管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div1">商品列表</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">{{ breadcrumbTitle }}</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>商品信息</h2>
    </div>
    <div class="content">
      <h3>基础信息</h3>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="110px" class="info-form">
        <el-form-item label="商品分类">
          <div class="goods-category-edit">
            <span>{{ categoryArrStr }}</span>
            <!-- <span class="edit-btn" @click="toEditCategory" v-if="infoForm.platformId == 0">编辑</span> -->
          </div>
        </el-form-item>
        <div style="display: flex;height: 61px">
          <el-form-item label="拣货单位" prop="pickingUnit">
            <el-select v-model="infoForm.pickingUnit" placeholder="请选择" clearable style="width: 161px;">
              <el-option label="重量" :value="1"></el-option>
              <el-option label="体积" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="重量（克）" prop="weight">
            <el-input v-model="infoForm.weight" placeholder="请输入重量" clearable style="width:161px;">
            </el-input>
          </el-form-item>
          <el-form-item label="体积（㎡）" prop="volume">
            <el-input v-model="infoForm.volume" placeholder="请输入体积" clearable style="width: 161px;">
            </el-input>
          </el-form-item>
        </div>

        <div style="display: flex;height: 61px">
          <el-form-item label="分仓" prop="warehouseType">
            <el-select v-model="infoForm.warehouseType" placeholder="请选择" clearable style="width: 161px;">
              <el-option label="天兰茶叶" :value="1"></el-option>
              <el-option label="京航电商" :value="2"></el-option>
              <el-option label="九航云选礼品" :value="3"></el-option>
              <el-option label="森仕传媒" :value="4"></el-option>
              <el-option label="健驰药业" :value="5"></el-option>
              <el-option label="总经办" :value="6"></el-option>
              <el-option label="商品管理中心" :value="7"></el-option>
              <el-option label="综合管理部中心" :value="8"></el-option>
              <el-option label="仓储物流中心" :value="9"></el-option>
              <el-option label="财务管理中心" :value="10"></el-option>
              <el-option label="宜关茶号" :value="11"></el-option>
              <el-option label="大客户事业部" :value="12"></el-option>
              <el-option label="招商业务部" :value="13"></el-option>
              <el-option label="拓星-林总" :value="14"></el-option>
              <el-option label="帝源河酒业" :value="15"></el-option>
              <el-option label="IT技术部" :value="16"></el-option>
              <el-option label="信息流量管理部" :value="17"></el-option>
              <el-option label="质检运营中心" :value="18"></el-option>
              <el-option label="待确认" :value="19"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="虚拟库存" prop="virtualStock">
            <el-select v-model="infoForm.virtualStock" placeholder="请选择" clearable style="width: 161px;">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="商品类型" prop="goodsType">
          <el-checkbox-group v-model="infoForm.goodsTypes">
            <el-checkbox v-for="(item, index) in dictionaries.goods_type" :key="index" :label="item.dictId">{{
              item.dictName
            }}</el-checkbox>
          </el-checkbox-group>
          <!-- <el-radio-group v-model="infoForm.goodsType" :disabled="currentPageStatus !== 'add'">
              <el-radio v-for="item in dictionaries.goods_type" :key="item.dictId" :value="item.dictId"
                :label="item.dictName" :name="item.dictId"></el-radio>
            </el-radio-group> -->
        </el-form-item>
        <el-form-item label="商品名称" prop="name" style="width: 830px;">
          <el-input v-model="infoForm.name" placeholder="请输入商品名称" maxlength="30" show-word-limit clearable></el-input>
        </el-form-item>
        <div style="display: flex;height: 61px">
          <el-form-item label="外部商品" prop="isOut">
            <el-radio-group v-model="infoForm.isOut" style="width: 205px;">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品外部编号" style="width: 500px;">
            <el-input v-model="infoForm.outGoodsNo" placeholder="请输入商品外部编号" maxlength="24" show-word-limit
              clearable></el-input>
          </el-form-item>
          <el-form-item label="对外商品" prop="foreignGoods">
            <el-radio-group v-model="infoForm.foreignGoods" style="width: 205px;">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>


        <el-form-item label="标签" prop="tagList">
          <div class="labelbox" style="flex-wrap: wrap">
            <div class="labelitem" style="margin-bottom: 10px" v-for="(item, index) in seletedTag"
              :key="'dd' + item.id">
              {{ item.tagName }}
              <i v-if="currentPageStatus !== 'details'" class="el-icon-circle-close labelicon"
                @click="deleteTag(index)"></i>
            </div>
            <div class="primary-button" v-if="currentPageStatus !== 'details'" @click="addTag()">
              添加标签
            </div>
            <!-- <el-button type="primary" style="margin-bottom: 10px;" @click="showTagDialog = true"
                >添加标签</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="商品编码" v-if="infoForm.goodsNo" class="goods-no">
          <el-input v-model="infoForm.goodsNo" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="参考链接" class="goods-no">
          <el-input v-model="infoForm.referLink" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brandId" class="brand-id">
          <el-select v-model="infoForm.brandId" placeholder="请选择所属品牌" filterable clearable>
            <el-option v-for="(item, index) in brandList" :key="index + item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content attr">
      <div class="attr-title">类目属性</div>
      <div class="attr-content">
        <h4>商品属性</h4>
        <template v-for="(item, index) in goodsAttrData">
          <h5>{{ item.name }}</h5>
          <div class="attr-list">
            <form-filed :formconfig="item.formconfig" :formData="item.formData" @formDataval="dialogClick"
              :ref="'formAttr' + item.id" />
          </div>
        </template>
      </div>
    </div>
    <div class="content image-text-form">
      <h3><span style="color: #f33f3f">*</span>运费设置</h3>
      <el-form label-width="100px">
        <el-form-item label="运费设置">
          <el-select style="width: 40%" v-model="infoForm.shippingTemplateId" @change="selectModel">
            <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-button type="text" style="margin-left: 10px">新增运费</el-button> -->
        </el-form-item>
        <el-form-item label="" v-if="isShowTemplate">
          <number v-if="detail.calculType == 1" :isEdit="false" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice" :key="Math.random()">
          </number>
          <weight v-if="detail.calculType == 2" :tableData="tableData" :freight="detail.freight"
            :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice" :isEdit="false"
            :key="Math.random()"></weight>
          <free-delivery v-if="tableDataF.length != 0" :tableData="tableDataF" style="margin-top: 10px"
            :isEdit="false"></free-delivery>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>图文信息</h3>
      <el-form label-width="100px">
        <el-form-item label="商品图片(0/10)">
          <label slot="label"><span style="color: red">*</span>商品图片({{
            fileList.length
          }}/10)</label>
          <div style="
                height: 17px;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 17px;
                color: #999999;
                opacity: 1;
                margin-bottom: 8px;
                margin-top: 10px;
              ">
            图片尺寸：建议上传750px*750px，每张上传大小不得超过8M,支持jpg、png格式
          </div>
          <div class="mobile-upload-wrapper">
            <upload-picture ref="uploadPicture" :limit="10" :list="fileList" @changeImage="changeImage" />
          </div>
          <!--          <upload-picture></upload-picture>-->
        </el-form-item>
        <!-- <el-form-item label="">
            图片尺寸：建议上传750px*750px，每张上传大小不得超过8M,支持jpg、png格式
          </el-form-item> -->
        <el-form-item label="商品详情">
          <label slot="label"><span style="color: red">*</span>商品详情</label>
          <div style="
                height: 17px;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 17px;
                color: #999999;
                opacity: 1;
                margin-bottom: 8px;
                margin-top: 12px;
              ">
            若批量上传，建议一次不过20张，且每张大小不超过8M，支持jpg，png格式
          </div>
          <!--          <editor :init="editorInit" v-model="infoForm.detail" api-key="70xmc76i21jyu8ob8fmf4dtcjfpz0atkne1ttkxppmzsu230"/>-->
          <!-- <tinymce v-model="infoForm.details"></tinymce> -->
          <quill-editor v-model="infoForm.details" ref="myQuillEditor" :options="editorOption"
            class="editor"></quill-editor>
          <div class="bottom" style="display: none">
            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="true" multiple
              :before-upload="beforeUpload" :http-request="uploadFile" :on-change="handleChange" ref="uploadicon">
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" id="sku-content">
      <h3>包含商品</h3>
      <div class="combine-goods-box">
        <!-- <div class="combine-title"></div> -->

        <div class="add-sub-goods">
          <el-button type="primary" @click="showAddSubGoodsDialog" style="margin-bottom: 10px">
            添加子商品
          </el-button>
        </div>

        <!-- 商品表格 -->
        <div class="combine-goods-table">
          <el-table :data="subGoodsList" border style="width: 100%" :header-cell-style="{
            'text-align': 'center',
            background: '#F8F8F8',
            color: '#333333',
            'font-weight': 'normal'
          }" :cell-style="{ 'text-align': 'center' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="sku" label="SKU编码" width="100"></el-table-column>
            <el-table-column prop="firstGoodsSpecItemContent" label="规格" width="120">
              <template slot-scope="scope">
                {{ scope.row.firstGoodsSpecItemContent }}
              </template>
            </el-table-column>
            <el-table-column prop="goodsName" label="商品名称" width="180"></el-table-column>
            <el-table-column prop="goodsNo" label="商品编码" width="120"></el-table-column>
            <el-table-column prop="quantity" label="*数量" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" size="small" placeholder="数量"
                  @change="updateQuantity(scope.$index)" min="1"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="marketPrice" label="市场价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.marketPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="costPrice" label="成本价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.costPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="retailPrice" label="零售价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.retailPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="purchasePrice" label="内购价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.purchasePrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="settlementPrice" label="结算价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.settlementPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="convertPrice" label="折算价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.convertPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="bulkPurchasePrice" label="集采价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.bulkPurchasePrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="agentPrice" label="代理价（元）" width="120">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.agentPrice) }}
              </template>
            </el-table-column>
            <el-table-column prop="stock" label="可用库存" width="100">
              <template slot-scope="scope">
                {{ scope.row.stock === null || scope.row.stock === undefined || scope.row.stock === '' ? '-' :
                  scope.row.stock }}
              </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量" width="80">
              <template slot-scope="scope">
                {{ formatWeight(scope.row.weight) }}
              </template>
            </el-table-column>
            <el-table-column prop="volume" label="体积（m³）" width="120">
              <template slot-scope="scope">
                {{ formatVolume(scope.row.volume) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" style="color: #F33F3F" @click="removeSubGoods(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 组合商品价格设置 -->
      <div class="content" style="margin-top: 10px;">
        <h3>组合商品价格设置</h3>
        <el-table :data="[combinationPrice]" border style="width: 100%" :header-cell-style="{
          'text-align': 'center',
          background: '#F8F8F8',
          color: '#333333',
          'font-weight': 'normal'
        }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="specification" label="规格" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specification" size="small" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="image" label="规格图片" width="120">
            <template slot-scope="scope">
              <mall-picture :imageUrl="scope.row.image" @getUrl="url => scope.row.image = url" />
            </template>
          </el-table-column>
          <el-table-column prop="marketPrice" label="组合市场价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.marketPrice" @blur="fixComboPrice('marketPrice')"
                @input="restrictToNumber($event, 'marketPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="costPrice" label="组合成本价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.costPrice" @blur="fixComboPrice('costPrice')"
                @input="restrictToNumber($event, 'costPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="retailPrice" label="*组合零售价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.retailPrice" @blur="fixComboPrice('retailPrice')"
                @input="restrictToNumber($event, 'retailPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="purchasePrice" label="*组合内购价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasePrice" @blur="fixComboPrice('purchasePrice')"
                @input="restrictToNumber($event, 'purchasePrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="settlementPrice" label="*组合结算价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.settlementPrice" @blur="fixComboPrice('settlementPrice')"
                @input="restrictToNumber($event, 'settlementPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="convertPrice" label="*组合折算价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.convertPrice" @blur="fixComboPrice('convertPrice')"
                @input="restrictToNumber($event, 'convertPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="bulkPurchasePrice" label="*组合集采价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.bulkPurchasePrice" @blur="fixComboPrice('bulkPurchasePrice')"
                @input="restrictToNumber($event, 'bulkPurchasePrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="agentPrice" label="*组合代理价（元）" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.agentPrice" @blur="fixComboPrice('agentPrice')"
                @input="restrictToNumber($event, 'agentPrice')" size="small" :min="0" :step="0.01">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="可用库存" width="100">
            <template slot-scope="scope">
              {{ combinationAvailableStock }}
            </template>
          </el-table-column>
          <el-table-column prop="virtualStock" label="虚拟库存" width="110">
            <template slot-scope="scope">
              <el-input v-model="scope.row.virtualStock" @input="restrictToNumber($event, 'virtualStock')" size="small"
                @blur="fixComboInt('virtualStock')" :min="0" :step="0.01"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="initSellNum" label="初始销量" width="110">
            <template slot-scope="scope">
              <el-input v-model="scope.row.initSellNum" @blur="fixComboInt('initSellNum')"
                @input="restrictToInteger($event, 'initSellNum')" size="small" :min="0">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="组合重量" width="110">
            <template slot-scope="scope">
              {{ formatWeight(combinationWeight) }}
            </template>
          </el-table-column>
          <el-table-column label="组合体积（m³）" width="130">
            <template slot-scope="scope">
              {{ formatVolume(combinationVolume) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="上下架" width="90">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#409EFF" inactive-color="#dcdfe6"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="resetCombinationPrice">重置价格</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-form label-width="100px">
          <el-form-item label="上架平台" prop="platformIds">
            <label slot="label">
              <!-- <span style="color: red">*</span> -->
              上架平台</label>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
              @change="handleCheckAllChange">全选(未选平台，默认五域上架)</el-checkbox>
            <el-checkbox-group v-model="infoForm.platformIds" @change="handleCheckedplatformChange">
              <el-checkbox v-for="item in platforms" :label="item.platformId" :key="item.platformId">{{
                item.platformName
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="平台是否审核上架" v-if="skuList.length < skuFormConfig.sku.length">
            <div slot="label" style="line-height: 20px">
              <span style="color: red">*</span>平台是否审核上架
            </div>
            <el-radio-group v-model="infoForm.isVerifyShelves" @change="selectIsUp">
              <el-radio v-for="item in dictionaries.is_verify_shelves" :key="item.dictId" :value="item.dictId"
                :label="item.dictId" :name="item.dictName">{{ item.dictName
                }}<el-tooltip v-if="item.dictId == 1" class="item" effect="dark" content="平台手动审核商品是否上架"
                  placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-tooltip v-if="item.dictId == 2" class="item" effect="dark" content="五域设定该商品直接在所选平台中售卖"
                  placement="top-start">
                  <i class="el-icon-question"></i> </el-tooltip></el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="infoForm.isVerifyShelves == 2 && showPlatform.length != 0" style="
                margin-left: 220px;
                margin-top: -20px;
                width: 710px;
                height: auto;
                background: #f1f6ff;
                opacity: 1;
                border-radius: 0px;
                padding-left: 12px;
                padding-top: 12px;
                padding-bottom: 12px;
              ">
            <div style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  line-height: 20px;
                  color: #333333;
                ">
              该商品直接上架平台<span v-if="showPlatform.length != 0">【</span>
              <span v-for="(item, index) in showPlatform" :key="index" style="color: red"><span v-if="index > 0"
                  style="color: red">，</span>{{ item.name }}</span>
              <span v-if="showPlatform.length != 0">】</span>平台的【收益】出现亏损！请重新选择上架平台
            </div>
            <div @click="qx" style="
                  width: 72px;
                  height: 24px;
                  background: #ffffff;
                  border: 1px solid #4168e7;
                  opacity: 1;
                  border-radius: 3px;
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  line-height: 24px;
                  color: #4168e7;
                  text-align: center;
                  margin-top: 10px;
                ">
              一键取消
            </div>
          </div>
          <el-form-item label="是否上架后续新增平台">
            <div slot="label" style="line-height: 20px">
              <span style="color: red">*</span>是否上架后续新增平台
            </div>
            <el-radio-group v-model="infoForm.isShelvesAddedPlatform">
              <el-radio v-for="item in dictionaries.is_shelves_added_platform" :key="item.dictId" :value="item.dictId"
                :label="item.dictId" :name="item.dictId">
                {{ item.dictName }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content bottom-but">
      <el-button type="warning" @click="toOtherPages('goodsList')">返回</el-button>
      <el-button type="primary" @click="submitAll" :disabled="showPlatform.length != 0 && infoForm.isVerifyShelves == 2"
        v-if="parArray.indexOf('eidt_chengbenjia') != -1">{{ submitButtonText }}</el-button>
      <el-button type="info" @click="importImage()">导出商品图片</el-button>
    </div>
    <el-dialog title="添加标签" :visible.sync="dialogVisible" append-to-body width="50%">
      <div class="loglabelbox">
        <div class="loglabeltopbox">
          <div class="labelitem" :style="{ cursor: item.select ? 'not-allowed' : 'pointer' }"
            :class="[item.select ? 'selected' : 'notselected']" v-for="(item, index) in tagList" :key="'dd' + item.id"
            @click="selectTagFn(index)">
            {{ item.tagName }}
          </div>
        </div>
        <div class="circlebox">
          已选
          <div class="circle">
            {{ seletedTag.length }}
          </div>
        </div>
        <div class="loglabeltopbox" style="border: none">
          <div class="labelitem labelitemc" v-for="(item, index) in seletedTag" :key="'dd' + item.id">
            {{ item.tagName }}
            <i class="el-icon-circle-close labelicon" @click="deleteTag(index)"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定SKU" :visible.sync="dialogSkuVisible" append-to-body width="32%">
      <div style="margin-left: 30px">
        SKU编码
        <el-input v-model="bindingSkuNo" placeholder="请输入所需绑定的SKU" style="width: 400px; margin-left: 15px"></el-input>
      </div>
      <span style="margin-left: 106px; color: #f33f3f; font-size: 12px">请留意新旧商品规格是否一致</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSkuVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindSku">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择标签" :visible.sync="showTagDialog" width="1010px" append-to-body>
      <div class="tag—table-box">
        <el-form ref="tagForm" :model="tagForm" :inline="true" id="search" size="small">
          <el-form-item label="标签" prop="name">
            <el-input v-model="tagForm.name" clearable placeholder="标签名称"></el-input>
          </el-form-item>
          <el-form-item label="类目" prop="tagClass">
            <el-select v-model="tagForm.tagClass" placeholder="请选择类目" clearable>
              <el-option v-for="item in dictionaries.goods_tag_class" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="primary-mini" @click="fetchData()">查询</div>
            <div class="primary-mini" @click="fetchData('reset')">重置</div>
            <!-- <el-button type="primary" @click="fetchData()">查询</el-button>
              <el-button type="primary" plain @click="fetchData('reset')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 20px">
          <div class="primary-plain" @click="batchSelectTag(1)">批量选择</div>
          <div class="primary-plain" @click="batchSelectTag(2)">批量取消</div>
          <!-- <el-button type="primary" size="mini" plain @click="batchSelectTag(1)">批量选择</el-button>
            <el-button type="primary" size="mini" plain @click="batchSelectTag(2)">批量取消</el-button> -->
        </div>
        <el-table :data="tagList" style="width: 100%" :header-cell-style="{ background: '#F8F8F8', color: '#333333' }"
          @selection-change="handleSelectionChange" :cell-style="{ padding: '0' }">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="标签" prop="tagName"></el-table-column>
          <el-table-column label="排序" prop="sort"></el-table-column>
          <el-table-column label="标签分类" prop="typeName"></el-table-column>
          <el-table-column label="标签类目" prop="className"></el-table-column>
          <el-table-column label="是否对外展示" prop="" align="center">
            <template slot-scope="scope">
              <p style="text-align: center">
                {{ scope.row.showFlag == 1 ? "是" : "否" }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="tagName" align="center">
            <template slot-scope="scope">
              <div class="tag-status">
                <div class="circle1" :style="{
                  'background-color':
                    scope.row.status == 1 ? '#67c23a' : 'red',
                }"></div>
                <span>{{ scope.row.status == 1 ? "启用" : "停用" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template slot-scope="scope">
              <el-button type="text" v-if="!scope.row.selected" @click="handleSelectTag(scope)">选择</el-button>
              <el-button type="text" style="color: red" v-if="scope.row.selected"
                @click="handleSelectTag(scope)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="
              margin-bottom: 20px;
              background-color: #f8f8f8;
              overflow: hidden;
            ">
          <div style="float: right">
            <el-pagination v-if="tagList.length > 0" background @size-change="onSizeChange"
              @current-change="onCurrentChange" :current-page="labelPageNo" :page-sizes="[10, 20, 50]"
              :page-size="labelPageSize" layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="primary-gray" @click="showTagDialog = false">关 闭</div>
        <!-- <div class="primary-button" @click="showTagDialog = false">确 定</div> -->
        <!-- <el-button @click="showTagDialog = false">取 消</el-button>
          <el-button type="primary" @click="showTagDialog = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="关联商品" :visible.sync="isGoods" append-to-body width="40%" :close-on-click-modal="false">
      <div style="display: flex; justify-content: start" v-for="(item, index) in skus" :key="index">
        <div style="display: flex; margin-bottom: 20px">
          <div style="line-height: 30px; margin-right: 20px">绑定SKU</div>
          <div>
            <el-input v-model="item.bindGoodsSku" placeholder="请输入绑定的SKU" size="small" style="width: 232px"
              @change="selectSku($event, index)" oninput="value=value.replace(/|[^0-9]/g, '')"></el-input>
          </div>
        </div>
        <div style="display: flex">
          <div style="line-height: 30px; margin-right: 20px; margin-left: 20px">
            绑定数量
          </div>
          <div>
            <el-input v-model="item.goodsQuantity" placeholder="请输入绑定的数量" style="width: 232px" size="small"
              oninput="value=value.replace(/|[^0-9]/g, '')"></el-input>
          </div>
        </div>
        <div @click="deleteSku(index)" style="color: red; line-height: 30px; margin-left: 20px;cursor: pointer;">
          删除
        </div>
      </div>
      <div>
        <el-button type="text" @click="addGoodsSku">增加绑定</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isGoods = false">取 消</el-button>
        <el-button type="primary" @click="bindSkuGoods">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialog1.title" :visible.sync="dialog1.visible" :width="dialog1.width" :append-to-body="true">
      <template>
        <div style="display: flex">
          <div>
            <el-button plain :type="isUp === 'up' ? 'primary' : 'info'" @click="isUpPlatform(1)">已上架平台</el-button>
            <el-button plain :type="isUp === 'down' ? 'primary' : 'info'" @click="isUpPlatform(0)">待上架平台</el-button>
          </div>
          <div class="dialog-search" style="margin-top: 4px">
            <el-form :inline="true" class="search-form" size="small" style="margin-left: 4px">
              <el-form-item label="平台名称" prop="name">
                <el-input v-model="platformName" placeholder="请输入平台名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="dialog-button">
            <el-button type="primary" size="small" @click="goodsPlatformPrice()">查询</el-button>
          </div>
        </div>
        <el-table border :data="dialog1.list" :span-method="objectSpanMethod" style="width: 100%">
          <el-table-column prop="name" label="平台名称"> </el-table-column>
          <!-- <el-table-column prop="skuName" label="商品规格"> </el-table-column> -->
          <el-table-column prop="marketPrice" label="市场价" v-if="dialog1.type === 'marketPrice'">
            <template slot-scope="scope">
              <el-input :disabled="scope.row.type == 0" v-model="scope.row.marketPrice">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="retailPrice" label="零售价" v-if="dialog1.type === 'retailPrice'">
            <template slot-scope="scope">
              <el-input v-model="scope.row.retailPrice" :disabled="scope.row.type == 0">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="purchasePrice" label="内购价" v-if="dialog1.type === 'purchasePrice'">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasePrice" :disabled="scope.row.type == 0">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="settlementPrice" label="结算价" v-if="dialog1.type === 'settlementPrice'">
            <template slot-scope="scope">
              <el-input v-model="scope.row.settlementPrice" :disabled="scope.row.type == 0">
              </el-input>
            </template>
          </el-table-column>

          <el-table-column prop="stock" label="可用库存" v-if="dialog1.type === 'stock'">
            <template slot-scope="scope">
              <el-input v-model="scope.row.store" :disabled="platformId !== 0">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="上下架" v-if="dialog1.type === 'status'">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-value="1" inactive-value="0"
                @change="controlUp(scope.row, scope.$index)"></el-switch>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-pagination">
          <el-pagination @size-change="handleSizeChangeDialog" @current-change="handleCurrentChangeDialog"
            :current-page="1" :page-sizes="[10, 20, 30, 40]" :page-size="10"
            layout="total, sizes, prev, pager, next, jumper" :total="dialog1.totalNum">
          </el-pagination>
          <div style="text-align: center; margin-top: 20px">
            <el-button type="primary" @click="submitSingle">确定</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="dialogCategory" append-to-body width="32%">
      <categoryDialog :categoryIds="cIds" @changeC="changeC"></categoryDialog>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="dialogSinfo" append-to-body width="32%">
      是否确认增加【
      <span v-for="(item, index) in addSku" :key="index" style="color: red"><span v-if="index > 0"
          style="color: red">，</span>{{ item.sku }}</span>】商品？
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSinfo = false">取 消</el-button>
        <el-button type="primary" @click="verificationData">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示信息" :visible.sync="isS" width="643px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left;margin-left: 60px;">
          <i class="el-icon-warning" style="color: red; font-size: 20px"></i>
          <span>{{ msg }}</span>
        </div>
        <div v-if="gL.length != 0" style="
                width:468px;
                background: #F1F6FF;
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  line-height: 22px;
                  color: #333333;
                  margin-left: 60px;
                  margin-top:15px;
                  padding:12px 10px
                ">
          该商品已被<span v-if="gL.length != 0" style="color:#2d7edf">【</span>
          <span v-for="(item, index) in gL" :key="index" style="color:  #4168E7"><span v-if="index > 0"
              style="color:  #4168E7">，&nbsp;</span>{{ item }}</span>
          <span v-if="gL.length != 0" style="color:#2d7edf">】</span>关联，若确认下架，则所关联的商品都下架！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isS = false">取消</div>
          <div class="info-s" @click="isSsubmit()">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="选择子商品" :visible.sync="addSubGoodsDialogVisible" append-to-body width="930px"
      :close-on-click-modal="false">
      <div class="sub-goods-dialog">
        <!-- 搜索条件 -->
        <div class="btnBox">
          <el-form :inline="true" :model="subGoodsSearch" size="small">
            <el-form-item>
              <div class="input-with-select">
                <el-select class="category-select" v-model="dynamicSearch.value" style="width: 90px;" clearable
                  @change="handleDynamicSearchTypeChange">
                  <el-option label="商品名称" value="goodsName"></el-option>
                  <el-option label="赠品名称" value="giftName"></el-option>
                </el-select>
                <el-input v-model="dynamicSearch.keyword" @keyup.enter.native="searchSubGoods" placeholder="请输入"
                  clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="input-with-select">
                <span class="prepend-text">商品规格</span>
                <el-input v-model="subGoodsSearch.goodsNo" placeholder="请输入" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="input-with-select">
                <span class="prepend-text">商品规格编码</span>
                <el-input v-model="subGoodsSearch.skuNo" placeholder="请输入" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="input-with-select">
                <span class="prepend-text">分仓</span>
                <el-select v-model="subGoodsSearch.warehouseType" placeholder="请选择" clearable>
                  <el-option label="天兰茶叶" value="1"></el-option>
                  <el-option label="京航电商" value="2"></el-option>
                  <el-option label="九航云选礼品" value="3"></el-option>
                  <el-option label="森仕传媒" value="4"></el-option>
                  <el-option label="健驰药业" value="5"></el-option>
                  <el-option label="总经办" value="6"></el-option>
                  <el-option label="商品管理中心" value="7"></el-option>
                  <el-option label="综合管理部中心" value="8"></el-option>
                  <el-option label="仓储物流中心" value="9"></el-option>
                  <el-option label="财务管理中心" value="10"></el-option>
                  <el-option label="宜关茶号" value="11"></el-option>
                  <el-option label="大客户事业部" value="12"></el-option>
                  <el-option label="招商业务部" value="13"></el-option>
                  <el-option label="拓星-林总" value="14"></el-option>
                  <el-option label="帝源河酒业" value="15"></el-option>
                  <el-option label="IT技术部" value="16"></el-option>
                  <el-option label="信息流量管理部" value="17"></el-option>
                  <el-option label="质检运营中心" value="18"></el-option>
                  <el-option label="待确认" value="19"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="searchSubGoods">查询</el-button>
              <el-button size="mini" @click="resetSubGoodsSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 商品列表表格 -->
        <div class="dialog-table">
          <lb-table v-horizontal-scroll='"always"' border :column="subGoodsColumns" align="center"
            :data="subGoodsCandidateList" pagination :total="subGoodsPage.totalNum"
            :current-page.sync="subGoodsPage.currentPage" :page-size="subGoodsPage.pageSize"
            @size-change="handleSubGoodsSizeChange" @p-current-change="handleSubGoodsCurrentChange"
            @refresh="refreshSubGoods" :orderStatistics="subGoodsPage.totalNum" statisticText="当前列表统计总商品数"
            @selection-change="handleSubGoodsSelectionChange" :row-key="getRowKey">
          </lb-table>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addSubGoodsDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddSubGoods">确定添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册

// import Tinymce from '@/components/Tinymce/index'
import uploadPicture from '@/components/upload/dragpicture.vue'
// import sku from "./components/sku/index"
import formFiled from '@/components/form/index'
import SkuForm from 'vue-sku-form'
import mixinsGoodsEdit from './mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from './mixins/mixinsGoodsEditQuill1.js'

import mixinsGiftlist from './mixins/mixinsGiftlist.js'

import ModifyState from './components/ModifyState.vue'

import common from '../matrix/mixins/common'
import number from './components/number.vue'
import weight from './components/weight.vue'
import FreeDelivery from './components/freeDelivery.vue'
import mallPicture from '@/components/upload/mallPicture.vue'
import categoryDialog from './components/categoryDialog.vue'
import batchInput from '@/components/batchInput.vue'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import LbTable from '@/pages/purchase/components/lb-table/lb-table'
const checkNumber = (data, index, callback) => {
  const val = data[index].stock
  // console.log(typeof val === 'number', !isNaN(val))
  console.log(typeof val === 'number' && !isNaN(val))
  if (!isNaN(val)) {
    callback()
  }
  callback(new Error('填写有误'))
}
export default {
  components: {
    uploadPicture,
    formFiled,
    SkuForm,
    quillEditor,
    ModifyState,
    number,
    weight,
    FreeDelivery,
    mallPicture,
    categoryDialog,
    batchInput,
    LbTable
  },
  data() {
    return {
      // v1.9.3新增
      subGoodsList: [], // 已添加的子商品列表
      addSubGoodsDialogVisible: false, // 选择子商品弹窗
      subGoodsCandidateList: [], // 可选子商品列表
      // 组合商品价格设置（单行，按设计稿）
      combinationPrice: {
        // 编辑态用于回传
        id: '',
        skuNo: '',
        specification: '',
        image: '',
        costPrice: '',
        retailPrice: '',
        purchasePrice: '',
        settlementPrice: '',
        convertPrice: '',
        bulkPurchasePrice: '',
        agentPrice: '',
        virtualStock: 0,
        initSellNum: 0,
        status: true,
      },
      combinationAvailableStock: 0, // 可用库存（由子商品库存/数量计算）
      combinationWeight: 0, // 组合重量（kg，由子商品重量*数量汇总）
      combinationVolume: 0, // 组合体积（m³，由子商品体积*数量汇总）
      dynamicSearch: {
        value: 'goodsName',
        keyword: '',
      },
      subGoodsSearch: {
        goodsName: '',
        specification: '',
        sku: '',
        warehouseType: '',

      },
      subGoodsPage: {
        currentPage: 1,
        pageSize: 10,
        totalNum: 0,
      },
      selectedSubGoods: [], // 选中的子商品
      // 子商品表格列配置
      subGoodsColumns: [
        { label: '选择', type: 'selection', width: '55', reserveSelection: true },
        { label: '序号', type: 'index', width: '55' },
        { label: '商品编码', prop: 'goodsNo', width: '130' },
        { label: '商品名称', prop: 'goodsName', width: '130' },
        { label: '商品规格', prop: 'specification', width: '130' },
        { label: '商品规格编码', prop: 'sku', width: '130' },
        { label: '商品分类', prop: 'categoryPath', width: '130' },
        { label: '所属分仓', prop: 'warehouseTypeName', width: '130' },
      ],

      gIndex: '',
      rows: {},
      isS: false,
      gL: [],
      msg: '',
      isGoods: false,
      dialogSinfo: false,
      dialogCategory: false,
      addSku: [],
      showPlatform: [],
      isStatus: 1,
      time: 0,
      models: [

      ],
      radio: 3,
      platformName: '',
      isPlatform: false,
      isUp: 'up',
      fileList: [],
      currentPageStatus: 'add', // 当前页面状态 add 添加 ， edit 编辑
      breadcrumbTitle: '组合商品编辑',
      maxSkuNo: 1, // 通过接口获取最大 skuNo
      formFiledDataState: true, // 类目属性 状态
      skuFormConfig: {
        sourceAttribute: [], // SKU可选属性
        attribute: [], // SKU已选属性，支持 .sync 修饰符
        structure: [ // 表单结构
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'slot', label: '市场价(元)', required: true, batch: false,
            // validate: (data, index, callback) => {
            //   console.log(data[index].marketPrice)
            //   const val = data[index].marketPrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)

                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'slot', label: '零售价(元)', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   const val = data[index].retailPrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'purchasePrice', type: 'input', label: '内购价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].purchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].purchasePrice = Number(data[index].purchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'settlementPrice', type: 'slot', label: '结算价(元)', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   const val = data[index].purchasePrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].settlementPrice = Number(data[index].settlementPrice).toFixed(2)
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'convertPrice', type: 'input', label: '折算价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].convertPrice = Number(data[index].convertPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'bulkPurchasePrice', type: 'input', label: '集采价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].bulkPurchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].bulkPurchasePrice = Number(data[index].bulkPurchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'agentPrice', type: 'input', label: '代理价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].agentPrice
              if (!isNaN(val) && val > -1) {
                data[index].agentPrice = Number(data[index].agentPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'weight', type: 'input', label: '重量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          {
            name: 'volume', type: 'input', label: '体积', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].volume
              if (!isNaN(val) && val > -1) {
                data[index].volume = Number(data[index].volume).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        structure1: [ // 表单结构
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   console.log(data)
            //   // const val = data[index].marketPrice
            //   // if (!isNaN(val) && val > -1) {
            //   //   data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //   //   callback()
            //   // }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'marketPrice', type: 'slot', label: '市场价(元)', required: true, batch: false,
            // validate: (data, index, callback) => {
            //   console.log(data[index].marketPrice)
            //   const val = data[index].marketPrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'costPrice', type: 'input', label: '成本价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].costPrice = Number(data[index].costPrice).toFixed(2)

                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'slot', label: '零售价(元)', batch: false, required: true,
            // validate: (data, index, callback) => {
            //   const val = data[index].retailPrice
            //   if (!isNaN(val) && val > -1) {
            //     data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
            //     callback()
            //   }
            //   callback(new Error('填写有误'))
            // }
          },
          {
            name: 'convertPrice', type: 'input', label: '折算价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].costPrice
              if (!isNaN(val) && val > -1) {
                data[index].convertPrice = Number(data[index].convertPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'bulkPurchasePrice', type: 'input', label: '集采价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].bulkPurchasePrice
              if (!isNaN(val) && val > -1) {
                data[index].bulkPurchasePrice = Number(data[index].bulkPurchasePrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'agentPrice', type: 'input', label: '代理价(元)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].agentPrice
              if (!isNaN(val) && val > -1) {
                data[index].agentPrice = Number(data[index].agentPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'weight', type: 'input', label: '重量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
          {
            name: 'status',
            type: 'slot',
            defaultValue: '1',
            label: '上下架',
            tip: '单个 SKU 上架和下架状态！'
          },
          { name: 'bindingSkuNo', type: 'slot', label: '手动绑定SKU', batch: false, tip: '适用于【九航】系统(普通商品和身份商品)' },
          { name: 'relationSku', type: 'slot', label: '关联商品', batch: false, tip: '该规格绑定多个商品，实际按绑定规格发货' },
        ],
        sku: [], // SKU数据，支持 .sync 修饰符
        theme: 2, // SKU选择栏主题风格，可选1或2
        showForm: true, // 是否显示SKU选择栏  false 显示 true 隐藏
        inputValueArr: [],
        inputValueArrTemp: []
      },
      submitButtonText: '发布商品', // 提交按钮方案
      infoForm: { // 基础信息
        categoryId: '', //	是	int	类目id （数据来源：接口 - /order/comm/commodityCategory/commList）
        goodsTypes: [], //	是	string	商品类型（字典：goods_type）
        name: '', //	是	string	商品名称
        isOut: '', // 是否外部商品 1是，0不是
        brandId: '', //	是	int	品牌id（数据来源：接口 - /order/comm/brand/commList?pageNo=1&pageSize=999）
        attrList: '', //	是	Object[]	商品属性组列表
        // imageList: [{url: "http://fenxiao.muruji.com/internalSystem/76c19d4d-5a0e-4ff2-9b4f-239040be1d58"}], //	是	Object[]	图片列表
        imageList: [], //	是	Object[]	图片列表
        details: '', //	否	string	详情
        specList: [], //	是	Object[]	规格列表
        skuList: [], //	是	Object[]	sku列表
        status: '', //	是	string	状态（字典分组：enable_status）
        goodsNo: '', // 商品编号
        referLink: '', // 参考链接
        maxPrice: '', // 最高价
        minPrice: '', // 最低价
        submitButtonText: '发布商品', // 提交按钮方案
        tagList: [],//标签
        shippingTemplateId: '',//运费Id
        isVerifyShelves: '',//平台是否审核上架
        isShelvesAddedPlatform: '',//是否上架后续新增平台
        platformIds: [],
        freightModeId: null,
        freightTemplateId: null,
        outGoodsNo: '',
        foreignGoods: null,
        pickingUnit: '', // 抹货单位
        weight: '', // 重量（克）
        volume: '', // 体积（㎡）
        warehouseType: '', // 分仓
        virtualStock: '', // 虚拟库存
        productType: '', // 天兰茶叶
        ecommerceChannel: '', // 电商
      },
      isShowTemplate: false,
      infoRules: { // 基础验证
        pickingUnit: [
          { required: true, message: '请选择拣货单位', trigger: 'change' }
        ],
        warehouseType: [
          { required: true, message: '请选择分仓类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        isOut: [
          { required: true, message: '请选择是否外部商品', trigger: 'blur' }
        ],
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        goodsTypes: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      categoryIdArr: [], // 获取路由 categoryId
      categoryArrStr: '', // 回显 category
      goodsAttrDataList: [], // 类目商品属性库列表
      goodsSaleDataList: [], // 类目的销售属性列表
      goodsSaleDataListValue: [],
      goodsAttrData: [{ formconfig: {}, formData: {} }],
      formFiledData: {}, // 表单组件数 商品属性组列表
      currentStatus: 100, // 当前列表状态
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      dialog1: { visible: false, title: '编辑', type: '', row: {}, skuId: null, list: [], batch: false, titleArr: [], totalNum: 0, page: 1, pageNo: 10, shopId: null, platformId: [], platformIds: [] },
      selectionId: [], // 选 中 id
      parArray: [], // 按钮权限
      skuList: [],
      lastSkuStatus: [],
      changeGoodsStatusNum: 0,
      tagList: [],//标签
      seletedTag: [],
      dialogVisible: false,
      dialogSkuVisible: false,
      tagForm: {
        name: '',
        tagType: '1',
        tagClass: ''
      },
      labelPageNo: 1,
      labelPageSize: 10,
      labelTotalNum: 0,
      showTagDialog: false,
      tagSelectionList: [],
      bindingSkuNo: '',
      skuIndex: 0,
      editTagList: [],
      detail: {},
      tableData: [],
      tableDataF: [],
      platforms: [],
      platforms1: [],
      isIndeterminate: true,
      checkAll: false,
      sIndex: null,
      platformId: 0,
      cIds: [],
      skus: [
        // {
        //   bindGoodsSku: '',
        //   goodsQuantity: null,
        //   name: '',
        //   status: ''
        // }
      ],
      goodsL: [],
      gIndex: 0,
      goods: [],
      isOriginFlag: 0,
      isW: 1,
    }
  },
  beforeDestroy() {
    // 清理工作
  },
  mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill, mixinsGiftlist, common],
  // mounted () { this.addQuillTitle() },
  created() {
    this.initialization() // 初始化 信息
    this.getButtonTreeDto() // 获取权限设定
    this.getTagList() // 获取标签数据
    this.getList()//获取模板列表
    console.log(this.dictionaries)
    this.getDictionaries('is_verify_shelves')
    this.getDictionaries('is_shelves_added_platform')
    // this.getPlatformList()
  },
  watch: {
    subGoodsList: {
      handler() {
        this.recalcCombinationDerived()
      },
      deep: true
    },
    infoForm: {
      handler(newVal, oldVal) {
        // console.log('infoForm', newVal)
        const rQuery = this.$route.query
        const goodsId = rQuery.id
        // console.log('goodsId', [goodsId])
        // if (newVal && newVal.status && newVal.status.indexOf('下') > -1 && rQuery.type === 'edit' && this.changeGoodsStatusNum > 3) {
        //   // console.log(newVal.status, this.changeGoodsStatusNum)
        //   // this.checkGiftListByGoodId([goodsId])
        // }
        console.log(newVal.skuList)
        this.changeGoodsStatusNum++
      },
      deep: true
    },
    skuFormConfig: {
      handler(newVal, oldVal) {
        console.log(newVal, this.skuList)
        this.$nextTick(() => {
          this.addSku = []
          newVal.sku.forEach(item => {
            if (item.skuNo == '') {
              this.addSku.push(item)
            }
          })
          // this.skuFormConfig.sku[this.sIndex].marketPrice = newVal.sku[this.sIndex].marketPrice

          // this.skuFormConfig.sku[this.sIndex].marketPrice = newVal.sku[this.sIndex].marketPrice
          this.$forceUpdate()

        })
        // this.skuFormConfig.sku[this.sIndex].marketPrice = newVal.sku[this.sIndex].marketPrice
        if (this.sIndex != null) {
          this.skuFormConfig.sku[this.sIndex].status = String(this.skuList[this.sIndex].status)
        }

        console.log(this.skuFormConfig.sku)
        this.$forceUpdate()
        const rQuery = this.$route.query
        // console.log('skuList', this.infoForm.skuList)
        // const arr = []
        // let skuStatusNum = 0
        // newVal.sku.forEach(item => {
        //   arr.push(item.marketPrice)
        //   if (item.status === '0') { skuStatusNum++ }
        // })
        // if (newVal.sku.length === skuStatusNum) {
        //   this.infoForm.status = this.dictionaries.sale_status[0].dictName
        //   console.log(this.infoForm.status)
        //   // console.log('下')
        // }
        // if (rQuery.type === 'edit') {
        //   // this.isActionCheckGift(newVal, oldVal)
        // }
        // // this.checkGiftListBySkuId(skuIds)
        // const sortArr = arr.sort(function (a, b) { return a - b })
        // // console.log(sortArr)
        // this.infoForm.maxPrice = sortArr[sortArr.length - 1] // 最高价
        // this.infoForm.minPrice = sortArr[0] // 最低价
        this.$forceUpdate()
      },
      deep: true // 为true，表示深度监听，这时候就能监测到a值变化
    },
    goodsSaleDataListValue(a, b) {
      console.log(a, b)
      if (this.skuFormConfig.attribute.length > 3) {
        this.$message({
          message: '规格最多只有三条',
          type: 'warning'
        })
        this.onChangeGoodsSaleDataListValue(b)
      }
    }
  },
  computed: {},
  methods: {
    // 限制输入只能为整数
    restrictToInteger(event, field) {
      let value = event;
      if (typeof event === 'object') {
        value = event.target.value;
      }

      // 移除非数字的字符
      let newValue = value.replace(/\D/g, '');

      // 更新值
      this.combinationPrice[field] = newValue;
    },
    // 限制输入只能为数字和小数点
    restrictToNumber(event, field) {
      let value = event;
      if (typeof event === 'object') {
        value = event.target.value;
      }

      // 移除非数字和小数点的字符，但允许小数点
      let newValue = value.replace(/[^\d.]/g, '');

      // 确保只有一个小数点
      const parts = newValue.split('.');
      if (parts.length > 2) {
        newValue = parts[0] + '.' + parts.slice(1).join('');
      }

      // 更新值
      this.combinationPrice[field] = newValue;
    },
    sanitizedFileName(fileName) {
      // 使用正则表达式匹配并替换特殊字符
      return fileName.replace(/[\\\/:*?"<>]/g, '_');
    },
    fixComboPrice(field) {
      const v = Number(this.combinationPrice[field])
      if (this.combinationPrice[field] === '' || this.combinationPrice[field] === null || this.combinationPrice[field] === undefined) {
        return
      }
      if (isNaN(v) || v < 0) {
        this.$set(this.combinationPrice, field, '')
        return
      }
      this.$set(this.combinationPrice, field, v.toFixed(2))
    },
    fixComboInt(field) {
      const v = Number(this.combinationPrice[field])
      if (this.combinationPrice[field] === '' || this.combinationPrice[field] === null || this.combinationPrice[field] === undefined) {
        this.$set(this.combinationPrice, field, 0)
        return
      }
      if (isNaN(v) || v < 0) {
        this.$set(this.combinationPrice, field, 0)
        return
      }
      this.$set(this.combinationPrice, field, Number(v).toFixed(0))
    },
    recalcCombinationDerived() {
      let sumWeight = 0
      let sumVolume = 0
      let minStock = null
      this.subGoodsList.forEach(row => {
        const qty = Number(row.quantity) || 0
        const w = Number(row.weight) || 0
        const vol = Number(row.volume) || 0
        const st = Number(row.stock)
        sumWeight += w * qty
        sumVolume += vol * qty
        if (!isNaN(st) && qty > 0) {
          const can = Math.floor(st / qty)
          minStock = minStock === null ? can : Math.min(minStock, can)
        }
        if (isNaN(st) && minStock === null) {
          minStock = 0
        }
      })
      this.combinationWeight = sumWeight
      this.combinationVolume = sumVolume
      this.combinationAvailableStock = minStock === null ? 0 : Math.max(0, minStock)
    },
    resetCombinationPrice() {
      const fields = ['marketPrice', 'costPrice', 'retailPrice', 'purchasePrice', 'settlementPrice', 'convertPrice', 'bulkPurchasePrice', 'agentPrice']
      const sums = {}
      fields.forEach(f => { sums[f] = 0 })
      this.subGoodsList.forEach(row => {
        const qty = Number(row.quantity) || 0
        fields.forEach(f => {
          const n = Number(row[f]) || 0
          sums[f] += n * qty
        })
      })
      fields.forEach(f => {
        this.$set(this.combinationPrice, f, Number(sums[f]).toFixed(2))
      })
    },
    importImage() {
      this.axios.get('/goods/goods/getAllImages?goodsId=' + this.$route.query.id).then(async res => {
        if (res.code == 0) {
          const zip = new JSZip();
          const list = [
            ...(res.data.mainImageList || []),
            ...(res.data.detailImageList || []),
            ...(res.data.skuImageList || [])
          ].map(item => ({
            name: this.sanitizedFileName(item.fileName),
            url: item.url
          }));

          try {
            // 使用 Promise.all 等待所有图片下载完成
            await Promise.all(list.map(async item => {
              const response = await fetch(item.url);
              const contentType = response.headers.get('content-type');
              const extension = contentType ? contentType.split('/')[1] : 'jpg';  // 默认jpg
              const blob = await response.blob();
              zip.file(`${item.name}.${extension}`, blob);
            }));

            // 所有图片都处理完后，生成并下载 zip
            const blob = await zip.generateAsync({ type: "blob" });
            saveAs(blob, `${this.infoForm.goodsNo}+${this.infoForm.name}`);
          } catch (error) {
            console.error('下载图片出错:', error);
            // 这里可以添加错误提示
          }
        }
      })
    },
    isSsubmit() {
      this.isS = false
      if (this.isOriginFlag == 1) {
        for (let i = 0; i < this.dialog1.list.length; i++) {
          this.dialog1.list[i].status = '0'
        }
      } else if (this.isOriginFlag == 0 && this.isW == 1) {
        for (let i = 0; i < this.dialog1.list.length; i++) {
          if (i <= 0) {

          } else {
            this.dialog1.list[i].status = '0'
          }

        }
      }
      // if (this.dialog1.list[this.gIndex].status == 0) {
      //   this.dialog1.list[this.gIndex].status = 1
      // } else {
      //   this.dialog1.list[this.gIndex].status = 0
      // }

    },
    controlUp(row, index) {
      console.log(row, index, this.isUp)
      this.isOriginFlag = row.originFlag
      this.gIndex = index
      if (row.name == '五域') {
        this.isW = 1
      } else {
        this.isW = 0
      }
      if (this.isUp == 'up') {
        if (row.status == 1) {
          row.status = 0
        } else {
          row.status = 1
        }
        if (row.originFlag == 1 && row.status == 1) {
          this.isS = true
          this.msg = '是否确认下架来源平台？该平台下架后，该商品上架的所有平台都下架!'
          // this.gIndex = index
          this.dialog1.list[this.gIndex].status = '1'
        } else if (row.originFlag == 0 && this.isW == 1 && row.status == 1) {
          let data = {
            goodsId: this.$route.query.id,
            platformId: 0,
            isMain: 1,
            status: 0
          }
          this.$api.goodIsPutOffCheck(data).then(res => {
            if (res.code == 0) {
              console.log(res.data)
              let str = ''
              if (res.data.goodsNameList) {
                this.isS = true
                this.msg = '下架五域平台，除来源平台，所有同步的平台都下架'
                this.gIndex = index
                this.gL = res.data.goodsNameList
                this.rows = row
                this.dialog1.list[this.gIndex].status = '1'
              } else {
                this.isS = true
                this.gIndex = index
                this.msg = '下架五域平台，除来源平台，所有同步的平台都下架'
                this.rows = row
                this.dialog1.list[this.gIndex].status = '1'
              }
            }
          })
        } else if (row.status == 0 && this.dialog1.list[0].status == '0' && row.originFlag != 1) {
          this.isS = true
          this.msg = '来源平台已下架，不能操作上架'
          // this.gIndex = index
          this.dialog1.list[this.gIndex].status = '0'
        } else if (row.status == 1) {
          this.dialog1.list[this.gIndex].status = '0'
        } else if (row.status == 0) {
          this.dialog1.list[this.gIndex].status = '1'
        }
      } else {
        console.log(111)
        if (row.status == 1) {
          row.status = 0
        } else {
          row.status = 1
        }
        if (row.originFlag == 1 && this.isW == 1 && row.status == 0 && row.bindSkuStatus == 0) {

          this.isS = true
          this.msg = '绑定的SKU编码已下架不能上架'
          // this.gIndex = index
          this.dialog1.list[this.gIndex].status = '0'
        } else if (row.originFlag == 0 && row.originStatus == 0 && row.status == 0 && this.dialog1.list[0].status == 0) {

          this.isS = true
          this.msg = '来源平台源平台商品SKU已下架，不能操作上架'
          // this.gIndex = index
          this.dialog1.list[this.gIndex].status = '0'
        } else {
          if (this.dialog1.list[this.gIndex].status == 0) {
            this.dialog1.list[this.gIndex].status = '1'
          } else {
            this.dialog1.list[this.gIndex].status = '0'
          }

        }

      }
      // let data = {

      // }
      // let msg = ''
      // if (row.name == '五域' && row.status == 0) {
      //   data = {
      //     goodsId: this.$route.query.id,
      //     platformId: 0,
      //     isMain: 1,
      //     status: 0
      //   }
      //   this.$api.goodIsPutOffCheck(data).then(res => {
      //     if (res.code == 0) {
      //       console.log(res.data)
      //       let str = ''
      //       if (res.data.goodsNameList) {
      //         this.isS = true
      //         this.msg = '是否确认下架五域的平台？该平台下架后，该商品上架的所有平台都下架!'
      //         this.gIndex = index
      //         this.gL = res.data.goodsNameList
      //         this.rows = row
      //         this.dialog1.list[this.gIndex].status = '1'
      //       } else {
      //         this.isS = true
      //         this.gIndex = index
      //         this.msg = '是否确认下架五域的平台？该平台下架后，该商品上架的所有平台都下架!'
      //         this.rows = row
      //         this.dialog1.list[this.gIndex].status = '1'
      //       }
      //     }
      //   })
      // } else if (row.name == '五域' && row.status == 1 && row.bindSkuStatus == 0 && row.originFlag == 1) {
      //   this.isS = true
      //   this.gIndex = index
      //   this.msg = '绑定的SKU编码已下架不能上架'
      //   this.rows = row
      //   this.dialog1.list[this.gIndex].status = '0'
      //   this.isUp = 'down'
      // } else if (row.originFlag == 1 && row.name != '五域' && row.status == 1) {
      //   this.isS = true
      //   this.gIndex = index
      //   this.msg = '是否确认下架来源平台？该平台下架后，该商品上架的所有平台都下架!'
      //   this.rows = row
      //   this.dialog1.list[this.gIndex].status = '0'
      //   this.isUp = 'down'
      // } else if (row.originFlag == 0 && row.name !== '五域' && row.status == 1 && row.originStatus == 0) {
      //   this.isS = true
      //   this.gIndex = index
      //   this.msg = '来源平台已下架，五域不能操作上架'
      //   this.rows = row
      //   this.dialog1.list[this.gIndex].status = '0'
      //   this.isUp = 'down'
      // }
    },
    //表格合并行和列
    objectSpanMethod1({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.goodsL.length
      for (let i = 0; i < len; i++) {
        const item = this.goodsL[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuName == this.goodsL[i - 1].skuName) {
            item.$rows = 0
            this.goodsL[pos].$rows = this.goodsL[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    showDialogGoodsVisible(e, index) {
      this.gIndex = index
      this.isGoods = true
      if (this.skuFormConfig.sku[this.gIndex] && this.skuFormConfig.sku[this.gIndex].relationSku) {
        console.log(this.skuFormConfig.sku[this.gIndex].relationSku)
        this.skus = this.skuFormConfig.sku[this.gIndex].relationSku
      } else {
        this.skus = []
      }

    },
    selectSku(val, index) {
      console.log(val)
      let skus = JSON.parse(JSON.stringify(this.skus))
      skus.splice(index, 1)
      let isC = skus.find(item => item.bindGoodsSku == val)
      console.log(isC)
      if (isC) {
        this.$message.error('绑定SKU重复')
        return
      }
      this.axios.post('/goods/goodsSkuBindSku/getSkuInfo', { sku: val }).then(res => {
        if (res.code == 0) {
          console.log(res.data)
          this.skus[index].name = res.data.name
          this.skus[index].status = res.data.status
          this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
        } else {
          this.$message.error(res.message)
          this.skus[index].bindGoodsSku = ''
        }
      })
      // this.$api.getSkuInfoList({ sku: val }).then(res => {
      //   if (res.code == 0) {
      //     console.log(res.data)
      //     this.skus[index].name = res.data.name
      //     this.skus[index].status = res.data.status
      //     this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
      //   }
      // })
    },
    //关联商品
    bindSkuGoods() {
      if (!this.skuFormConfig.sku[this.gIndex]) {
        this.$message.error('规格数据未填')
        return
      }
      // this.skus.forEach(item=>)
      let isS = this.skus.every(item => item.bindGoodsSku != '' && item.goodsQuantity != '')
      if (!isS) {
        this.$message.error('存在未填写的SKU或者数量')
        return

      }
      let skus = this.skus.map(item => item["bindGoodsSku"]);
      let S = new Set(skus);
      if (S.size == skus.length) {
        console.log("无重复");
      } else {
        this.$message.error('绑定SKU重复')
        return
      }
      console.log(this.skuFormConfig)
      this.skuFormConfig.sku[this.gIndex].relationSku = this.skus
      this.$nextTick(() => {
        // 规格列表
        const skuFormConfigAttribute = this.skuFormConfig.attribute
        skuFormConfigAttribute.forEach(firstItem => {
          firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
          firstItem.itemList.forEach(secondItem => {
            secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
          })
        })
        // 合并新添加的规格值
        skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
          const inputValueArr = this.skuFormConfig.inputValueArr
          firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
          firstItem.itemList = Array.from(new Set(firstItem.itemList))
        })

        const tempAttribute = this.skuFormConfig.attribute
        const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
        console.log(skuFormConfigSku)
        skuFormConfigSku.forEach(item => {
          console.log(item.sku)
          item.sku = item.sku.split('_')
        })
        skuFormConfigSku.forEach((firstItem, firstIndex) => {
          const attributeLength = skuFormConfigAttribute.length
          firstItem.sort = 1
          firstItem.sku.forEach((secondItem, secondIndex) => {
            switch (attributeLength) {
              case 1:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                break
              case 2:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.secondGoodsSpecName = tempAttribute[1].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
                break
              case 3:
                firstItem.firstGoodsSpecName = tempAttribute[0].name
                firstItem.secondGoodsSpecName = tempAttribute[1].name
                firstItem.thirdGoodsSpecName = tempAttribute[2].name
                firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
                firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
                firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
                break
            }
          })
        })
        console.log(skuFormConfigSku)

        this.goods = []
        skuFormConfigSku.forEach(item => {
          let str = ''
          str = item.sku[0].replace(';', '_')
          item.skuName = str
          let obj = {
            skuName: item.skuName,
            skus: item.relationSku
          }
          this.goods.push(obj)
        })
        console.log(this.goods)
        this.goodsL = []
        let renderList = []
        this.goods.forEach(item => {
          if (item.skus) {
            console.log(item.skus)
            item.skus.forEach(itm => {
              itm.skuName = item.skuName
              renderList.push(itm)
              // this.goodsL = renderList
            })
          }
        })
        this.goodsL = renderList

      })
      this.isGoods = false
    },
    //删除sku
    deleteSku(index) {
      this.skus.splice(index, 1)
    },
    //关联商品sku添加
    addGoodsSku() {
      let obj = {
        name: '',
        status: '',
        bindGoodsSku: '',
        goodsQuantity: '',
      }
      this.skus.push(obj)
    },
    changeM(key, index) {
      console.log(index)
      this.$nextTick(() => {
        this.$refs.skuForm.init()
        this.skuFormConfig.sku[index][key] = Number(this.skuFormConfig.sku[index][key]).toFixed(2)
        // console.log(this.skuFormConfig.sku[index].marketPrice, 5555)
        this.$forceUpdate()

      })

    },
    // 处理动态搜索类型变化
    handleDynamicSearchTypeChange() {
      this.dynamicSearch.keyword = ''; // 清空输入框内容
    },
    showAddSubGoodsDialog() {
      this.addSubGoodsDialogVisible = true;
      this.searchSubGoods();
    },
    searchSubGoods() {
      const params = {
        pageNo: this.subGoodsPage.currentPage,
        pageSize: this.subGoodsPage.pageSize,
        ...this.subGoodsSearch,
        status: '1'
      };
      // 根据动态搜索类型设置参数
      if (this.dynamicSearch.value && this.dynamicSearch.keyword) {
        params[this.dynamicSearch.value] = this.dynamicSearch.keyword;
      }
      this.$api.goodsquerySkuList(params).then(res => {
        if (res.code === 0) {
          this.subGoodsCandidateList = res.data.list || [];
          this.subGoodsPage.totalNum = res.data.totalNum || 0;
          console.log(this.subGoodsCandidateList, '列表页数据');
        }
      });
    },
    // 重置搜索条件
    resetSubGoodsSearch() {
      this.subGoodsSearch = {
        goodsName: '',
        goodsNo: '',
        skuNo: '',
        warehouseType: '',
      };
      this.dynamicSearch = {
        value: 'goodsName',
        keyword: '',
      };
      this.subGoodsPage.currentPage = 1;
      this.searchSubGoods();
    },
    // 处理商品选择
    handleSubGoodsSelectionChange(selection) {
      this.selectedSubGoods = selection;
    },
    // 确认添加子商品
    confirmAddSubGoods() {
      // 未勾选任何商品
      if (this.selectedSubGoods.length === 0) {
        this.$message.warning('请至少选择一个商品');
        return;
      }

      // 已存在的 SKU 编码，用于去重
      const existSkuNos = this.subGoodsList.map(item => item.skuNo || item.sku);

      const newList = [];
      let duplicateCount = 0;

      this.selectedSubGoods.forEach(item => {
        const skuNo = item.skuNo || item.sku;
        if (skuNo && existSkuNos.indexOf(skuNo) !== -1) {
          duplicateCount += 1;
          return;
        }
        // 深拷贝一份，避免和弹窗列表数据互相影响
        const copy = { ...item };
        // 默认数量 1，可在"包含商品"表格中修改
        if (!copy.quantity || copy.quantity <= 0) {
          copy.quantity = 1;
        }
        // 子商品价格/库存来自子商品SKU信息（只读展示）
        // 若接口未返回，兜底为 0，避免因不可编辑导致无法提交
        const num2 = (v) => (v === '' || v === null || v === undefined || isNaN(Number(v))) ? '0.00' : Number(v).toFixed(2)
        copy.costPrice = num2(copy.costPrice)
        copy.retailPrice = num2(copy.retailPrice)
        copy.purchasePrice = num2(copy.purchasePrice)
        copy.settlementPrice = num2(copy.settlementPrice)
        copy.convertPrice = num2(copy.convertPrice)
        copy.bulkPurchasePrice = num2(copy.bulkPurchasePrice)
        copy.agentPrice = num2(copy.agentPrice)
        copy.stock = (copy.stock === '' || copy.stock === null || copy.stock === undefined || isNaN(Number(copy.stock))) ? 0 : Number(copy.stock).toFixed(0)
        // 确保skuNo字段存在
        if (!copy.skuNo && copy.sku) {
          copy.skuNo = copy.sku;
        }
        newList.push(copy);
      });

      if (duplicateCount > 0) {
        this.$message.warning('已自动过滤掉重复的子商品');
      }

      if (newList.length === 0) {
        // 全部都是重复的
        this.$message.warning('所选子商品均已存在于列表中');
        return;
      }

      // 追加到"包含商品"表格
      this.subGoodsList = this.subGoodsList.concat(newList);
      console.log(this.subGoodsList, '子商品列表');
      this.recalcCombinationDerived()
      // 若组合价格未填写，默认按子商品汇总填充一次
      const anyPriceFilled = ['marketPrice', 'costPrice', 'retailPrice', 'purchasePrice', 'settlementPrice', 'convertPrice', 'bulkPurchasePrice', 'agentPrice']
        .some(f => this.combinationPrice[f] !== '' && this.combinationPrice[f] !== null && this.combinationPrice[f] !== undefined)
      if (!anyPriceFilled) {
        this.resetCombinationPrice()
      }

      // 关闭弹窗并清空选择
      this.addSubGoodsDialogVisible = false;
      this.selectedSubGoods = [];
    },
    // 选择弹窗表格 row-key，保证多选在翻页后仍然保留
    getRowKey(row) {
      return row.skuNo || row.id;
    },
    // 弹窗分页：修改每页条数
    handleSubGoodsSizeChange(size) {
      this.subGoodsPage.pageSize = size;
      this.subGoodsPage.currentPage = 1;
      this.searchSubGoods();
    },
    // 弹窗分页：切换页码
    handleSubGoodsCurrentChange(page) {
      this.subGoodsPage.currentPage = page;
      this.searchSubGoods();
    },
    // 刷新子商品列表
    refreshSubGoods() {
      this.searchSubGoods();
    },
    // 价格类字段统一两位小数展示
    formatPrice(val) {
      if (val === null || val === undefined || val === '') {
        return '-';
      }
      const num = Number(val);
      if (isNaN(num)) return '-';
      return num.toFixed(2);
    },
    // 重量展示，保留 3 位小数
    formatWeight(val) {
      if (val === null || val === undefined || val === '') {
        return '-';
      }
      const num = Number(val);
      if (isNaN(num)) return '-';
      return num.toFixed(3);
    },
    // 体积展示，保留 3 位小数
    formatVolume(val) {
      if (val === null || val === undefined || val === '') {
        return '-';
      }
      const num = Number(val);
      if (isNaN(num)) return '-';
      return num.toFixed(3);
    },
    // 修改"包含商品"表格中的数量
    updateQuantity(index) {
      const row = this.subGoodsList[index];
      if (!row) return;
      const num = Number(row.quantity);
      if (isNaN(num) || num <= 0) {
        this.$set(this.subGoodsList[index], 'quantity', 1);
        this.$message.warning('数量必须大于 0');
      }
      this.recalcCombinationDerived()
    },
    // 删除"包含商品"表格中的一行
    removeSubGoods(index) {
      this.subGoodsList.splice(index, 1);
      this.recalcCombinationDerived()
    },
    // 验证价格字段
    validatePrice(index, field) {
      const row = this.subGoodsList[index];
      if (!row) return;
      const value = Number(row[field]);
      if (isNaN(value) || value < 0) {
        this.$set(this.subGoodsList[index], field, '');
        this.$message.warning(`${this.getPriceLabel(field)}必须大于等于0`);
      } else {
        // 保留两位小数
        this.$set(this.subGoodsList[index], field, value.toFixed(2));
      }
    },
    // 获取价格字段标签
    getPriceLabel(field) {
      const labels = {
        costPrice: '成本价',
        retailPrice: '零售价',
        purchasePrice: '内购价',
        settlementPrice: '结算价',
        convertPrice: '折算价',
        bulkPurchasePrice: '集采价',
        agentPrice: '代理价',
        marketPrice: '市场价'
      };
      return labels[field] || field;
    },
    submitAll() {
      let arr = []
      this.skuFormConfig.sku.forEach(item => {
        if (item.skuNo == '') {
          arr.push(item)
        }
      })

      if (arr.length != 0) {
        this.dialogSinfo = true
      } else {
        this.verificationData()
      }

    },
    selectIsUp() {
      if (this.infoForm.isVerifyShelves == 2) {
        this.verificationData1()
      }
    },
    qx() {
      console.log(this.showPlatform, this.infoForm.platformIds)
      for (let i = 0; i < this.infoForm.platformIds.length; i++) {
        for (let j = 0; j < this.showPlatform.length; j++) {
          if (this.infoForm.platformIds[i] == this.showPlatform[j].id) {
            this.infoForm.platformIds.splice(i, 1)
          }
        }
      }
      console.log(this.infoForm.platformIds)
      this.showPlatform = []
    },
    changeC(val) {
      console.log(val)
      this.dialogCategory = false
      // this.infoForm.categoryId = val[2]
      // this.getPlatformList(val[1])
      // this.categoryIdArr = val
      // this.getCategoryList(val) // 获取 目类 列表
      // this.getDataList(val[val.length - 1])
      // this.getGoodsSaleDataList(val[val.length - 1]) // 查询指定类目的销售属性
      // this.getBrandList(val[val.length - 1]) // 获取 品牌 列表
      this.$router.push({
        name: 'goodsAdd',
        query: { type: 'edit', category: val, id: this.$route.query.id }
      })
      // let data = {
      //   id: this.$route.query.id
      // }
      // this.$api.goodsDelete(data).then(res => {
      //   if (res.code == 0) {
      //     this.$mesage.success('操作成功')
      //   }
      // })
    },
    toEditCategory() {
      let ids = []
      this.infoForm.categoryInfoList.forEach(item => {
        ids.push(item.id)
      })
      this.cIds = ids.reverse()
      this.dialogCategory = true

    },
    submitSingle() {



      console.log('this.dialog1.list', this.dialog1.list)
      let data = {
        id: this.dialog1.skuId,
        skuArray: this.dialog1.list
      }
      console.log(this.dialog1.list)
      this.$api.goodSkuEdit(data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.dialog1.visible = false
          console.log(this.skuList, this.skuFormConfig.sku, this.dialog1.list)
          this.$refs.skuForm.init()
          this.skuFormConfig.sku.forEach(item => {
            this.dialog1.list.forEach(itm => {
              if (item.skuNo == itm.skuNo) {
                this.skuFormConfig.sku[this.sIndex].marketPrice = itm.marketPrice
                this.skuFormConfig.sku[this.sIndex].retailPrice = itm.retailPrice
                // this.skuFormConfig.sku[this.sIndex].purchasePrice = itm.purchasePrice
                this.skuFormConfig.sku[this.sIndex].settlementPrice = itm.settlementPrice
                this.skuFormConfig.sku[this.sIndex].stock = itm.store
                this.skuFormConfig.sku[this.sIndex].status = String(itm.status)
                this.skuList[this.sIndex].status = String(itm.status)
                // item = itm
              }
            })
          })
          this.$forceUpdate()
        }
      })
    },
    isUpPlatform(val) {
      this.isStatus = val
      if (val == 1) {
        this.isUp = 'up'
      } else {
        this.isUp = 'down'
      }
      this.goodsPlatformPrice()
    },
    goodsPlatformPrice() {
      let type = ''
      console.log(this.dialog1.type)
      if (this.dialog1.type == 'marketPrice') {
        type = '1'
      } else if (this.dialog1.type == 'retailPrice') {
        type = '2'
      } else if (this.dialog1.type == 'settlementPrice') {
        type = '3'
      } else if (this.dialog1.type == 'stock') {
        type = '4'
      }
      let bindGoodsSku = []
      console.log(this.skuFormConfig.sku[this.sIndex])
      if (this.skuFormConfig.sku[this.sIndex] && this.skuFormConfig.sku[this.sIndex].relationSku) {
        this.skuFormConfig.sku[this.sIndex].relationSku.forEach(item => {
          bindGoodsSku.push(item.bindGoodsSku)
        })
      } else {
        bindGoodsSku = []
      }

      let data = {
        id: this.infoForm.id,
        status: this.isStatus,
        name: this.platformName,
        pageSize: this.dialog1.pageNo,
        pageNo: this.dialog1.page,
        skuId: this.dialog1.skuId,
        type: type,
        bindSkuList: bindGoodsSku || []
      }
      this.dialog1.list = []
      this.$api.goodsPlatformPrice(data).then((res) => {
        // this.dialog.list = res.data.list
        let renderList = []
        res.data.list.forEach(item => {
          item.items.forEach(itm => {
            itm.name = item.name
            itm.status = String(itm.status)
            renderList.push(itm)
            this.dialog1.list = renderList
          })
        })

        this.dialog1.totalNum = res.data.totalNum
      }).catch((err) => {
        console.log(err)
      })
    },
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.dialog1.list.length
      for (let i = 0; i < len; i++) {
        const item = this.dialog1.list[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.name === this.dialog1.list[i - 1].name) {
            item.$rows = 0
            this.dialog1.list[pos].$rows = this.dialog1.list[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    openDialog(title, row, index) {
      console.log(index, this.skuFormConfig.sku)
      this.sIndex = index
      this.dialog1.visible = true
      this.isUp = 'up'
      console.log(row, this.skuList)
      this.platformId = this.skuList[index].platformId
      this.isStatus = 1
      console.log(this.platformId)
      this.skuList.forEach(item => {
        if (item.skuNo == row.skuNo) {
          this.dialog1.skuId = item.id
        }
      })
      if (title == 'marketPrice') {
        this.dialog1.title = '市场价'
      } else if (title == 'retailPrice') {
        this.dialog1.title = '零售价'
      } else if (title == 'purchasePrice') {
        this.dialog1.title = '内购价'
      } else if (title == 'settlementPrice') {
        this.dialog1.title = '结算价'
      } else if (title == 'stock') {
        this.dialog1.title = '库存'
      } else {
        this.dialog1.title = '状态'
        console.log(row, this.skuFormConfig.sku[index])
        this.$refs.skuForm.init()
        this.skuFormConfig.sku[index].status = String(this.skuList[index].status)
      }
      this.dialog1.width = '640px'

      this.dialog1.type = title
      this.goodsPlatformPrice()

    },
    handleCurrentChangeDialog(currentChange) {
      this.dialog1.pageNo = currentChange
      this.goodsPlatformPrice()
    },
    handleSizeChangeDialog(sizeChange) {
      this.dialog1.pageSize = sizeChange
      this.goodsPlatformPrice()
    },
    getImage(val, scope) {
      console.log(val)
      console.log(this.skuFormConfig)
      // this.skuFormConfig.sku[scope.$index].Img = val
      // this.skuFormConfig.attribute[scope.$index].Img = val
      // this.infoForm.skuList[scope.$index].image = val
      console.log(scope.$index)
      scope.row.image = val
      this.$refs.skuForm.validateFieldByRows(scope.$index, 'image', () => { })
    },
    handleCheckAllChange(val) {
      console.log(val)
      let arr = []
      this.platforms.forEach(item => {
        arr.push(item.platformId)
      })
      this.infoForm.platformIds = val ? arr : [];
      this.isIndeterminate = false;
    },
    handleCheckedplatformChange(value) {
      console.log(this.infoForm.platformIds, value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.platforms.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.platforms.length;
      this.$forceUpdate()
    },
    //获取平台列表
    getPlatformList(val) {
      this.infoForm.platformIds = []
      let data = {
        id: this.$route.query.id,
        name: '',
        categoryId: val
      }
      this.$api.goodsPlatformStatus3(data).then(res => {
        res.data.forEach(item => {
          if (this.$route.query.type == 'edit') {
            if (item.platformName != this.infoForm.platformName) {
              this.platforms.push(item)
            }
            if (item.status == 1) {
              this.infoForm.platformIds.push(item.platformId)
            }
          }

        })
        this.platforms = res.data
        this.infoForm.platformIds = [...new Set(this.infoForm.platformIds)]

        // console.log()
        // this.platforms = []
        console.log(this.platforms, '22222', this.infoForm.platformIds)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
        // console.log(this.dictionaries[type])
      }).catch((err) => {
        console.log(err)
      })
    },
    selectModel() {
      if (this.infoForm.shippingTemplateId) {
        this.$api.goodsModelDetail({ id: this.infoForm.shippingTemplateId }).then(res => {
          this.detail = res.data
          this.tableData = this.detail.regions || []
          this.tableData.forEach(item => {
            Object.assign(item, { address: item.betterAddress })
            Object.assign(item, { addressData: JSON.parse(item.regionJson) })
          })
          this.tableDataF = this.detail.freeList || []
          this.tableDataF.forEach(item => {
            Object.assign(item, { address: item.betterAddress })
            Object.assign(item, { addressData: JSON.parse(item.regionJson) })
          })
          this.isShowTemplate = true
          this.infoForm.freightModeId = this.infoForm.shippingTemplateId
          if (this.deatil && this.deatil.calculType == 1) {
            this.skuFormConfig.structure.splice(11, 1)
          }
        })

      } else {
        this.isShowTemplate = false
        this.infoForm.freightModeId = null
      }

    },
    getList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        name: '',
        isSync: ''
      }
      this.$api.goodsModelList(data).then(res => {
        let obj = {
          id: '',
          name: '无'
        }
        this.models.push(obj)
        this.models = this.models.concat(res.data.list)
      })
    },
    changeImage(val) {
      console.log(val)
      this.fileList = val
    },
    showDialogSkuVisible(e, scope) {
      console.log(e, scope)
      if (scope.row.bindingSkuNo) {
        this.bindingSkuNo = scope.row.bindingSkuNo
      } else {
        this.bindingSkuNo = ''
      }
      console.log(this.skuFormConfig)
      this.dialogSkuVisible = true;
      this.skuIndex = scope.$index;
    },
    bindSku() {
      if (this.bindingSkuNo == '' || this.checknumber(this.bindingSkuNo)) {
        this.$message({
          message: '请输入正确的sku编码',
          type: 'error'
        })
        return
      }
      console.log(this.skuFormConfig, this.skuIndex)
      this.dialogSkuVisible = false;
      this.skuFormConfig.sku[this.skuIndex].bindingSkuNo = this.bindingSkuNo;
      this.$forceUpdate()
      this.bindingSkuNo = '';
    },
    checknumber(String) {
      var Letters = "1234567890";
      var i;
      var c;
      for (i = 0; i < String.length; i++) {
        c = String.charAt(i);
        if (Letters.indexOf(c) == -1) {
          return true;
        }
      }
      return false;
    },

    fetchData(type) {
      this.labelPageNo = 1
      this.labelPageSize = 10
      if (type == 'reset') {
        this.$refs['tagForm'].resetFields()
        this.labelPageNo = 1
        this.labelPageSize = 10
      } else {

      }
      this.getTagList()
    },
    //选择标签
    handleSelectTag(scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          tagName: scope.row.tagName
        };

        this.seletedTag.push(data)
        this.tagList[scope.$index].selected = true;
      } else {

        let idx = this.seletedTag.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedTag.splice(idx, 1)
        this.tagList[scope.$index].selected = false;
      }
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      console.log(this.seletedTag)
      this.$forceUpdate()
    },
    //批量选择、批量取消标签
    batchSelectTag(type) {
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            tagName: i.tagName
          }
        }
      })
      // this.seletedTag = this.seletedTag.concat(arr);
      const map = new Map();
      const newArr = this.seletedTag.concat(arr).filter(v => !map.has(v.id) && map.set(v.id, 1));

      this.seletedTag = newArr
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    //标签多选
    handleSelectionChange(val) {
      this.tagSelectionList = val;
    },
    onSizeChange(e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange(e) {
      this.labelPageNo = e;
      this.getTagList()
    },
    deleteTag(idx) {
      this.tagList.forEach(item => {
        if (this.seletedTag[idx].id == item.id) {
          item.selected = false;
        }
      })
      this.seletedTag.splice(idx, 1)

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    selectTagFn(idx) {
      if (!this.tagList[idx].select) {
        this.tagList[idx].select = !this.tagList[idx].select;
        this.seletedTag.push(this.tagList[idx])
        this.infoForm.tagList = this.seletedTag.map(item => {
          return item.id
        })
      }

    },
    //获取标签数据
    getTagList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize
      }
      data = Object.assign(data, this.tagForm)
      this.$api.selectTagDataPage(data)
        .then(res => {
          console.log(res);
          res.data.list.forEach(item => {
            item.selected = false
          })
          this.tagList = res.data.list;
          this.seletedTag.forEach(item => {
            this.tagList.forEach(el => {
              if (item.id == el.id) {
                el.selected = true;
              }
            })
          })

          this.labelTotalNum = res.data.totalNum;
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取标签数据
    getSelectTagData() {
      this.$api.selectTagData({})
        .then(res => {
          // this.tagList = res.data;
          console.log()
          this.tagList = res.data.map(item => {
            return { tagName: item.tagName, id: item.id, select: false }
          })

        })
        .catch(err => {
          console.log(err);
        })
    },

    onChangeSkuStatus(e, row) {
      // console.log('onChangeSkuStatus', e, row)
      this.checkGift = { type: 'row', value: row }
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        if (row.skuNo == s.skuNo && row.status === '0') {
          nSkuIds.push(s.id)
          this.checkGift.value['id'] = s.id
        }
      })
      if (nSkuIds.length > 0) { this.checkGiftListBySkuId(nSkuIds) }
    },
    isActionCheckGift(newVal, oldVal) {
      // const rQuery = this.$route.query
      const lastSkuStatus = this.lastSkuStatus
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        newVal.sku.forEach(nItem => {
          if (nItem.status == 0 && nItem.skuNo !== '') {
            if (nItem.skuNo == s.skuNo) {
              nSkuIds.push(s.id)
            }
          }
        })
      })
      this.lastSkuStatus = nSkuIds
      console.log(nSkuIds.length, nSkuIds, lastSkuStatus.length, lastSkuStatus)
      if (nSkuIds.length > lastSkuStatus.length) {
        // this.checkGiftListBySkuId(nSkuIds)
      }
      // this.checkGiftListBySkuId (nSkuIds)
    },
    checkGiftListBySkuId(skuIds, type) {
      return new Promise((resolve, reject) => {
        this.$api.giftListBySkuId(skuIds).then((res) => {
          this.giftListByGoodId = res.data
          if (res.data.length > 0) {
            const titleArr = []
            titleArr.push(this.infoForm.name)
            if (!type) { this.showModifyState(res.data, titleArr) }
            // console.log('giftListByGoodId', res.data)
          }
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      })
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'goodsList'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })

      // 查看成本价权限
      console.log('查看成本价权限', this.parArray.indexOf('eidt_chengbenjia'), this.parArray.indexOf('eidt_chengbenjia') != -1, this.parArray)
      if (this.parArray.indexOf('eidt_chengbenjia') === -1) {
        this.skuFormConfig.structure.forEach((item, index) => {
          if (item.name === 'costPrice') {
            this.skuFormConfig.structure.splice(index, 1)
          }
        })
      }
    },
    // 接受表单组件的数据
    dialogClick(val, state) {
      // console.log(val, state)
      this.formFiledDataState = state
      this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    // 初始化 信息
    initialization() {
      const queryObj = this.$route.query
      let category
      // 判断是否有 商品 ID 和 TYPE 类型 双从判断 当前页面状态
      // 获取商品信息 - 编辑模式
      if (queryObj.id && queryObj.type === 'edit') {
        // console.log(queryObj)

        this.infoForm.categoryId = null
        this.getPlatformList(this.infoForm.categoryId)
        this.getGoodInfo(queryObj.id)
        this.currentPageStatus = 'edit'
        this.submitButtonText = '修改商品'
      } else {
        this.currentPageStatus = 'add'
        this.submitButtonText = '发布商品'
        this.skuFormConfig.structure.splice(10, 1)
        // 添加模式
        if (queryObj && queryObj.category) { category = this.$route.query.category }
        if (category && category.length !== 0) {
          this.infoForm.categoryId = category[2]
          let val = category[1]
          this.getPlatformList(val)
          this.categoryIdArr = category
          this.getCategoryList(category) // 获取 目类 列表
          // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
          this.getDataList(category[category.length - 1])
          this.getGoodsSaleDataList(category[category.length - 1]) // 查询指定类目的销售属性
          this.getBrandList(category[category.length - 1]) // 获取 品牌 列表
          // 初始化 上 下架 状态 , 为了等待数据返回添加一个 setTimeout
          setTimeout(() => {
            // 设置 商品类型、 是否上架 默认值
            // if (this.dictionaries.goods_type.length !== 0) { this.infoForm.goodsType = this.dictionaries.goods_type[0].dictName }
            if (this.dictionaries.sale_status.length !== 0) { this.infoForm.status = this.dictionaries.sale_status[1].dictName }
          }, 1000)
        } else {
          console.log('还没选择商品分类')
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
    },
    addTag() {
      this.showTagDialog = true
      // this.seletedTag = []
    },
    skuItemHandle(item) {
      let tempSkuName = ''; let differenceStr = ''; let tempSkuName1 = '';
      if (item.secondGoodsSpecItemId && item.thirdGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent},${item.thirdGoodsSpecItemContent}`
        tempSkuName1 = `${item.firstGoodsSpecItemContent}_${item.secondGoodsSpecItemContent}_${item.thirdGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId},${item.thirdGoodsSpecItemId}`
      } else if (item.secondGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId}`
        tempSkuName1 = `${item.firstGoodsSpecItemContent}_${item.secondGoodsSpecItemContent}`
      } else {
        tempSkuName = `${item.firstGoodsSpecItemContent}`
        tempSkuName1 = `${item.firstGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId}`
      }
      console.log(tempSkuName)
      const tempSKU = {
        id: item.id,
        sku: tempSkuName,
        difference: `${differenceStr}`,
        skuNo: item.skuNo,
        stock: item.stock,
        status: item.status,
        costPrice: item.costPrice,
        marketPrice: item.marketPrice,
        retailPrice: item.retailPrice,
        Img: item.Img,
        weight: item.weight,
        initSellNum: item.initSellNum,
        platformId: item.platformId,
        relationSku: item.relationSku || [],
        skuName: tempSkuName1
      }
      console.log(tempSKU)
      return tempSKU
    },
    // 获取 商品信息
    getGoodInfo(goodsId) {
      console.log(this.skuFormConfig)
      this.breadcrumbTitle = '编辑商品'
      const params = { id: goodsId }
      this.$api.goodsCombinationDetail(params).then((res) => {
        const categoryId = res.data.categoryInfo.id
        this.infoForm = Object.assign(this.infoForm, res.data)
        this.fileList = this.infoForm.imageList
        this.infoForm.brandId = String(res.data.brandId)
        // 回显类目ID
        this.infoForm.categoryId = categoryId
        this.infoForm.isVerifyShelves = String(this.infoForm.isVerifyShelves)
        this.infoForm.isShelvesAddedPlatform = String(this.infoForm.isShelvesAddedPlatform)
        this.infoForm.shippingTemplateId = Number(res.data.freightModeId ? res.data.freightModeId : '')
        this.infoForm.foreignGoods = Number(this.infoForm.foreignGoods)
        if (this.infoForm.shippingTemplateId == 0) { this.infoForm.shippingTemplateId = '' }
        this.selectModel()

        // 回显子商品列表（组合商品）
        if (res.data.virtualSkuList && res.data.virtualSkuList.length > 0) {
          this.subGoodsList = res.data.virtualSkuList.map(item => {
            return {
              id: item.skuInfo?.id || item.id,
              sku: item.originalSkuNo || item.skuNo || item.sku,
              skuNo: item.originalSkuNo || item.skuNo || item.sku,
              goodsId: item.originalGoodsId || item.goodsId,
              goodsNo: item.goodsNo,
              goodsName: item.goodsName,
              specification: item.specification || '',
              quantity: item.quantity || 1,
              marketPrice: item.skuInfo?.marketPrice || item.marketPrice || '',
              costPrice: item.skuInfo?.costPrice || item.costPrice || '',
              retailPrice: item.skuInfo?.retailPrice || item.retailPrice || '',
              purchasePrice: item.skuInfo?.purchasePrice || item.purchasePrice || '',
              settlementPrice: item.skuInfo?.settlementPrice || item.settlementPrice || '',
              convertPrice: item.skuInfo?.convertPrice || item.convertPrice || '',
              bulkPurchasePrice: item.skuInfo?.bulkPurchasePrice || item.bulkPurchasePrice || '',
              agentPrice: item.skuInfo?.agentPrice || item.agentPrice || '',
              stock: item.skuInfo?.stock || item.stock || '',
              weight: item.weight || '',
              volume: item.volume || '',
              categoryPath: item.categoryPath || '',
              warehouseTypeName: item.warehouseTypeName || '',
              firstGoodsSpecItemContent: item.firstGoodsSpecItemContent || '',
              secondGoodsSpecItemContent: item.secondGoodsSpecItemContent || '',
              originalGoodsNo: item.originalGoodsNo || '',
              originalGoodsName: item.originalGoodsName || '',
            }
          })
        }

        // 回显组合商品自身价格设置（skuList 通常为 1 条）
        const comboSku = (res.data.skuList && res.data.skuList.length > 0) ? res.data.skuList[0] : null
        if (comboSku) {
          const to2 = (v) => (v === '' || v === null || v === undefined || isNaN(Number(v))) ? '' : Number(v).toFixed(2)
          this.combinationPrice.id = comboSku.id || ''
          this.combinationPrice.skuNo = comboSku.skuNo || ''
          this.combinationPrice.specification = comboSku.firstGoodsSpecItemContent || ''
          this.combinationPrice.image = comboSku.image || ''
          this.combinationPrice.costPrice = to2(comboSku.costPrice)
          this.combinationPrice.marketPrice = to2(comboSku.marketPrice)
          this.combinationPrice.retailPrice = to2(comboSku.retailPrice)
          this.combinationPrice.purchasePrice = to2(comboSku.purchasePrice)
          this.combinationPrice.settlementPrice = to2(comboSku.settlementPrice)
          this.combinationPrice.convertPrice = to2(comboSku.convertPrice)
          this.combinationPrice.bulkPurchasePrice = to2(comboSku.bulkPurchasePrice)
          this.combinationPrice.agentPrice = to2(comboSku.agentPrice)
          this.combinationPrice.virtualStock = (comboSku.stock === null || comboSku.stock === undefined || comboSku.stock === '' || isNaN(Number(comboSku.stock))) ? 0 : Number(comboSku.stock).toFixed(0)
          this.combinationPrice.initSellNum = (comboSku.initSellNum === null || comboSku.initSellNum === undefined || comboSku.initSellNum === '' || isNaN(Number(comboSku.initSellNum))) ? 0 : Number(comboSku.initSellNum).toFixed(0)
          this.combinationPrice.status = String(comboSku.status) !== '0'
        }
        this.$nextTick(() => {
          this.recalcCombinationDerived()
        })
        // if (!this.detail && this.detail.calculType !== 2) {
        //   this.skuFormConfig.structure.splice(8, 1)
        // }

        // this.skuFormConfig.structure.splice(8, 1)

        /*
        this.infoForm.imageList.forEach(item => {
          if (item.url && item.url.indexOf('http://fenxiao.muruji.com/') !== 0) { item.url = this.ImgHttps + item.url }
        })
        */
        setTimeout(() => {
          // 回显 商品类型
          // if (this.dictionaries.goods_type.length !== 0) {
          //   const goodsTypeObj = this.dictionaries.goods_type.find(e => { return e.dictId === this.infoForm.goodsType })
          //   if (goodsTypeObj) { this.infoForm.goodsType = goodsTypeObj.dictName }
          // }
          // 回显 上架 与 下架状态
          if (this.dictionaries.sale_status.length !== 0) {
            const statusObj = this.dictionaries.sale_status.find(e => { return e.dictId === this.infoForm.status.toString() })
            if (statusObj) { this.infoForm.status = statusObj.dictName }
          }
        }, 1000)
        // if (this.infoForm.goodsType == '3') {
        //   this.skuFormConfig.structure = this.skuFormConfig.structure1
        // }
        let c = JSON.parse(JSON.stringify(res.data.skuList))
        let s = []
        console.log(res.data.skuList)
        res.data.skuList.forEach(item => {
          item.convertPrice = Number(item.convertPrice).toFixed(2)
          item.bulkPurchasePrice = Number(item.bulkPurchasePrice).toFixed(2)
          item.agentPrice = Number(item.agentPrice).toFixed(2)
          if (item.firstGoodsSpecItemContent == null && item.sku) {
            s.push(item.sku)
          }
        })
        console.log(s)
        if (s.length != 0) {
          this.axios.post('goods/goodsSku/updateOldBySkuList', s).then(res => {
            if (res.code == 0) {

            }
          })
        }

        // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
        this.getDataList(categoryId, res.data.attrGroupList)
        this.getCategoryList(categoryId, res.data.categoryInfoList)
        this.getBrandList(categoryId) // 获取 品牌 列表
        this.getSkuNo(goodsId) // 生成sku编码
        // 查询指定类目的销售属性
        this.getGoodsSaleDataList(categoryId, res.data.specList, res.data.skuList)
        const tempskuList = []
        res.data.skuList.forEach(e => {
          const itemHandle = this.skuItemHandle(e)
          tempskuList.push(itemHandle)
        })
        this.skuList = tempskuList
        console.log(this.skuList)
        // this.skuList.forEach(item => {
        //   // item.skuName = item.tempSkuName
        //   let obj = {
        //     skuName: item.skuName,
        //     skus: item.relationSku || []
        //   }
        //   this.goods.push(obj)
        // })
        // console.log(this.goods)
        // this.goodsL = []
        // let renderList = []
        // this.goods.forEach(item => {
        //   if (item.skus) {
        //     item.skus.forEach(itm => {
        //       itm.skuName = item.skuName
        //       renderList.push(itm)
        //       this.goodsL = renderList
        //     })
        //   }

        // })
        //回显平台
        // this.platformList.forEach(item => {
        //   if (item.status != 4) {
        //     this.infoForm.platformIds.push(item.platformId)
        //   }
        // })
        if (this.platformList)
          this.editTagList = res.data.tagList || [];
        if (this.tagList.length > 0) {
          console.log(555555)
          this.tagList.forEach(item => {
            this.editTagList.forEach(el => {
              if (el.id == item.id) {
                item.selected = true;
              }
            })
          })
          this.seletedTag = this.editTagList.map(item => {
            return {
              id: item.id,
              tagName: item.name
            }
          })
          this.infoForm.tagList = this.seletedTag.map(item => {
            return item.id
          })
        }
        // this.skuItemHandle()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList(categoryInfo, categoryInfoList) {
      // console.log(categoryInfo)
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.categoryList(params).then((res) => {
        this.categoryList = res.data.list
        this.onChangeEditClassId(categoryInfo, categoryInfoList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
    getDataList(categoryId, attrGroupList) {
      const params = { categoryId }
      this.$api.goodsAttrDataList(params).then((res) => {
        const resData = res.data
        const arr = []
        // debugger
        resData.forEach(firstItem => {
          const obj = {
            name: firstItem.name,
            id: firstItem.id,
            // 表单宽度  表单的list 表单的匹配规则
            formconfig: { labeWidth: 100, itemList: [], rules: {} },
            // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
            formData: {}
          }
          firstItem.itemList.forEach(secondItem => {
            // 字典 goods_attr_type
            // 1、文本 2、单选  3、多选  4、时间
            const type = Number(secondItem.typeFlag)
            let propId
            /*
            // 修改模式下，需要多添加一个 ID
            if(this.currentPageStatus == "edit"){
              attrGroupList.forEach( aItem => {
                aItem.itemList.forEach( aItemList => {
                  if(aItem.id == firstItem.id && aItemList.id == secondItem.id){
                    propId = `value-${firstItem.id}-${secondItem.id}-${aItemList.id}`;
                  }
                })
              })
            } else {
              propId = `value-${firstItem.id}-${secondItem.id}`;
            }
            */
            propId = `value-${firstItem.id}-${secondItem.id}`
            switch (type) {
              case 1: // 文本
                obj.formconfig.itemList.push({ type: 'input', prop: propId, placeholder: '请输入内容', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请输入内容', trigger: 'blur' }] })
                break
              case 2: // 单选
                const radiosArr = []
                /*
              secondItem.itemList.forEach( radiosItem => { radiosArr.push({label:radiosItem.label,value:radiosItem.id}) })
              obj.formconfig.itemList.push( { type:'radio', prop:propId, label:secondItem.name, radios:radiosArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ required: secondItem.requiredFlag == 0 ? false :true, message: '请选择内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(item => { radiosArr.push({ label: item.label, value: item.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: radiosArr, isMultiple: false })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请选择内容', trigger: 'change' }] })
                break
              case 3: // 多选
                // debugger
                const checkboxArr = []
                /*
              secondItem.itemList.forEach( checkboxItem => { checkboxArr.push({label:checkboxItem.label,value:checkboxItem.id}) })
              obj.formconfig.itemList.push( { type:'checkbox',prop:propId,label:secondItem.name, checkboxs:checkboxArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ type: 'array', required: secondItem.requiredFlag == 0 ? false :true, message: '请至少选择一个内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(checkboxItem => { checkboxArr.push({ label: checkboxItem.label, value: checkboxItem.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: checkboxArr, isMultiple: true, isCollapseTags: true })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请至少选择一个内容', trigger: 'blur' }] })
                // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
                // obj.formData = Object.assign(obj.formData, {[propId]:[]})
                break
              case 4: // 时间
                obj.formconfig.itemList.push({ type: 'datapicker', prop: propId, placeholder: '请选择日期', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ type: 'string', required: secondItem.requiredFlag != 0, message: '请选择日期', trigger: 'change' }] })
                break
              default: // 出错 - 不在设计范围
                console.log(typeof type, type)
              // 默认代码块
            }
          })
          arr.push(obj)
        })
        this.goodsAttrData = arr
        // 编辑状态下 类目属性 回显 值
        if (this.currentPageStatus === 'edit') { this.showGoodsAttrValue(arr) }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 编辑状态下 类目属性 回显 值
    showGoodsAttrValue(arr) {
      const attrGroupList = this.infoForm.attrGroupList
      // const original = [...arr]
      // this.goodsAttrData[0].formData["value-15-20"] = "20"
      // 准备匹配值
      attrGroupList.forEach(firstItem => {
        firstItem.itemList.forEach(secondItem => {
          secondItem.matchValue = `value-${firstItem.id}-${secondItem.id}`
        })
      })
      this.goodsAttrData.forEach((firstItem, firstIndex) => {
        firstItem.formconfig.itemList.forEach(secondItem => {
          attrGroupList.forEach(attFirstItem => {
            attFirstItem.itemList.forEach(attSecondItem => {
              if (attSecondItem.matchValue == secondItem.prop) {
                // 1、文本 2、单选  3、多选  4、时间
                switch (attSecondItem.typeFlag) {
                  case '1': // 文本
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '2': // 单选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '3': // 多选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  default: // 时间
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = attSecondItem.attrValueContent
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                }
              }
            })
          })
        })
      })
      // console.log(this.goodsAttrData[1].formData["value-15-20"])
    },
    // 选择销售属性
    onChangeGoodsSaleDataListValue(selectArr) {
      // sessionStorage.setItem('saleDataListValue', JSON.stringify(this.goodsSaleDataListValue))
      // this.skuFormConfig.attribute.splice(fatherIndex, 1)
      if (this.skuFormConfig.attribute.length >= 3) {
        console.log(this.skuFormConfig.attribute.length)
        console.log(selectArr.length)
        if (selectArr.length === 3) { selectArr.splice(3) }
        if (selectArr.length === 2) { selectArr.splice(2) }
        if (selectArr.length === 1) { selectArr.splice(1) }
      }
      this.goodsSaleDataListValue = selectArr
      const sourceAttribute = this.skuFormConfig.sourceAttribute
      const arr = []
      selectArr.forEach(item => {
        const matching = sourceAttribute.find(e => { return e.id === item })
        // console.log(matching)
        arr.push(matching)
      })
      const tempAttribute = []
      this.skuFormConfig.attribute.forEach(item => {
        if (item.id === undefined) {
          tempAttribute.push(item)
        }
      })
      this.skuFormConfig.attribute = tempAttribute
      // this.skuFormConfig.attribute = arr // SKU已选属性
      this.skuFormConfig.attribute = Array.from(new Set(this.skuFormConfig.attribute.concat(arr)))
      // ============== 初始 空数组，使用在添加新的属性  ==============
      this.skuFormConfig.inputValueArr = []
      this.skuFormConfig.inputValueArrTemp = []
      this.skuFormConfig.attribute.forEach((item, index) => {
        // this.skuFormConfig.inputValueArr.push({ name: '', item: [], itemList: [] })
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    onExceed() {
      selectArr.splice(selectArr.length - 1, 1)
      this.goodsSaleDataListValue = selectArr
      console.log('已经超出', this.goodsSaleDataListValue)
      console.log('已经超出', this.skuFormConfig.attribute)
    },
    // 查询指定类目的销售属性
    getGoodsSaleDataList(categoryId, goodsSpecList, goodsSpecTable) {
      console.log(this.skuFormConfig)
      const params = { categoryId }
      this.$api.categorySalesPecDetail(params).then((res) => {
        // ============== 初始SKU可选属性 ==============
        const modifySpecList = res.data
        // 修改 初始化 key 为 组件 所需要 key
        modifySpecList.forEach((e) => {
          const itemArr = []
          e.itemList.forEach((itemList) => {
            itemArr.push(itemList.content)
          })
          e.item = itemArr
        })
        // this.skuFormConfig.sourceAttribute = Array.from(new Set(modifySpecList)) // SKU可选属性
        // ============== 初始 回显 已选 SKU 值  ==============
        if (goodsSpecList && goodsSpecList.length !== 0) {
          goodsSpecList = goodsSpecList.sort(function (a, b) { return a.id - b.id })
          goodsSpecList.forEach(firstItem => {
            const itemArr = []
            firstItem.itemList.forEach(secondItem => {
              itemArr.push(secondItem.content)
            })
            firstItem.item = itemArr
          })
          this.skuFormConfig.attribute = goodsSpecList
          this.skuFormConfig.sourceAttribute = goodsSpecList
          // const tempSourceAttribute = Array.from(new Set(this.skuFormConfig.sourceAttribute.concat(goodsSpecList).filter(Boolean)))

          /**
           * 删除数组对象中重复的对象
           * arr: 源数组   filterField: 需要删除的重复字段，注意是字符串类型
           * 返回一个过滤好的，没有重复该字段filterField的数组
           * */
          // const filterArrObj = (arr, filterField) => {
          //   const newArr = arr.reduce((pre, cur) => pre.some(item => item[filterField] == cur[filterField])
          //     ? pre : [...pre, cur], [])
          //   return newArr
          // }
          // console.log(tempSourceAttribute)
          // this.skuFormConfig.sourceAttribute = filterArrObj(tempSourceAttribute, 'name')
          console.log(this.skuFormConfig)
          // const echoSpecList = []
        }
        console.log(goodsSpecTable)
        if (goodsSpecTable && goodsSpecTable.length !== 0) {
          goodsSpecTable.forEach(item => {
            const arr = []
            arr.push(item.firstGoodsSpecItemContent)
            if (item.secondGoodsSpecItemContent) { arr.push(item.secondGoodsSpecItemContent) }
            if (item.thirdGoodsSpecItemContent) { arr.push(item.thirdGoodsSpecItemContent) }
            item.sku = arr.join(';')
            item.status = item.status.toString()
          })
          this.skuFormConfig.sku = Array.from(new Set(goodsSpecTable))
          console.log(this.skuFormConfig, this.skuFormConfig.sku)
          // 还原数据时，SKU组件将 ID 过滤掉，先将 数据缓存到本地，提交数据时使用
          sessionStorage.setItem('skuFormConfigSku', JSON.stringify(goodsSpecTable))
        }
        const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
        console.log(skuFormConfigSku)
        this.goods = []
        skuFormConfigSku.forEach(item => {
          let str = ''
          str = item.sku.replace(';', '_')
          item.skuName = str
          let obj = {
            skuName: item.skuName,
            skus: item.relationSku
          }
          this.goods.push(obj)
        })
        console.log(this.goods)
        this.goodsL = []
        let renderList = []
        this.goods.forEach(item => {
          if (item.skus) {
            console.log(item.skus)
            item.skus.forEach(itm => {
              itm.skuName = item.skuName
              renderList.push(itm)
              // this.goodsL = renderList
            })
          }
        })
        this.goodsL = renderList

        /*
        // SKU已选属性 编辑模式下使用
        if (this.currentPageStatus !== 'add') {
          this.skuFormConfig.attribute = Array.from(new Set(selectedSku)) // SKU已选属性
          this.skuFormConfig.sku = Array.from(new Set(modifySpecTable)) // SKU数据
          this.$nextTick(_ => {
            this.$refs.skuForm.init()
            // 提交数据时使用
            sessionStorage.setItem('skuFormConfigSku', JSON.stringify(modifySpecTable))
          })
        }
        */
        // ============== 初始 空数组，使用在添加新的属性  ==============
        this.skuFormConfig.attribute.forEach((item, index) => {
          this.skuFormConfig.inputValueArr.push([])
          this.skuFormConfig.inputValueArrTemp.push('')
        })
        console.log('表刚刚改', this.skuFormConfig)
        // console.log(this.skuFormConfig)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 品牌 列表
    getBrandList(categoryId) {
      const params = { pageNo: 1, pageSize: 999, categoryId }
      this.$api.brandCommList1().then((res) => {
        this.brandList = res.data
        this.brandList.push({
          id: '-1',
          name: '其它'
        })
        console.log(this.brandList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // console.log(val)
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 修改 回显 classId
    onChangeEditClassId(categoryIdInfo, categoryInfoList) {
      // debugger
      let categoryId
      let categoryArrStr = ''
      if (typeof categoryIdInfo === 'string') {
        categoryId = categoryIdInfo
      } else {
        categoryId = categoryIdInfo[categoryIdInfo.length - 1]
      }
      const categoryList = this.categoryList
      if (categoryList.length < 0) { console.log('categoryList没到位！', categoryList) }
      const arr = []
      categoryList.forEach((firstItem, firstIndex) => {
        if (firstItem.id === categoryId) {
          console.log(firstItem.label)
          categoryArrStr = firstItem.label
          arr.push(firstItem.id)
          return
        }
        if (firstItem.children) {
          firstItem.children.forEach((secondItem, secondIndex) => {
            if (secondItem.id === categoryId) {
              categoryArrStr = `${firstItem.label} > ${secondItem.label}`
              arr.push(firstItem.id)
              arr.push(secondItem.id)
              return
            }
            if (secondItem.children) {
              secondItem.children.forEach((thirdItem, thirdIndex) => {
                if (thirdItem.id === categoryId) {
                  categoryArrStr = `${firstItem.label} > ${secondItem.label} > ${thirdItem.label}`
                  arr.push(firstItem.id)
                  arr.push(secondItem.id)
                  arr.push(thirdItem.id)
                  return
                }
              }) // third end
            }
          }) // second end
        }
      }) // first end

      if (categoryArrStr.length == '' || categoryArrStr.length < 0) {
        if (categoryInfoList) {
          categoryInfoList.reverse()
          const tempArr = []
          categoryInfoList.forEach(item => {
            tempArr.push(item.categoryName)
          })
          categoryArrStr = tempArr.join(' > ')
          console.log(categoryArrStr)
        } else {
          console.log('还没选择商品分类1', categoryArrStr)
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
      this.categoryArrStr = categoryArrStr
    },
    // 生成sku编码
    getSkuNo(id) {
      // 主键id请求
      const params = { id }
      this.$api.gkuNoByGoodId(params).then((res) => {
        this.maxSkuNo = Number(res.data) // 获取 的 skuNo 转数字，方便后面使用可以自增
      }).catch((err) => {
        console.log(err)
      })
    },
    async verificationData() {
      this.dialogSinfo = false
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      if (infoForm.name && infoForm.name !== '') {
        const goodsId = infoForm.id || ''
        const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
        // console.log('isRepeatGoodsName', isRepeatGoodsName)
        if (isRepeatGoodsName.code !== 0) {
          // this.$message.warning('商品名称有重名，请重新输入！')
          return console.log("商品有重名")
        }
      }
      console.log(8888888888)
      if (this.fileList.length == 0) {
        this.$message.warning('请上传商品图片')
        return
      }
      if (this.infoForm.details == '') {
        this.$message.warning('请填写商品详情')
        return
      }
      // 组合商品不需要规格，需要子商品列表
      if (this.subGoodsList.length == 0) {
        this.$message.warning('请至少添加一个子商品')
        return
      }
      // 验证组合商品价格设置（按设计稿必填项）
      const mustFields = [
        { key: 'retailPrice', label: '组合零售价' },
        { key: 'purchasePrice', label: '组合内购价' },
        { key: 'settlementPrice', label: '组合结算价' },
        { key: 'convertPrice', label: '组合折算价' },
        { key: 'bulkPurchasePrice', label: '组合集采价' },
        { key: 'agentPrice', label: '组合代理价' },
      ]
      for (let i = 0; i < mustFields.length; i++) {
        const f = mustFields[i]
        const v = this.combinationPrice[f.key]
        if (v === '' || v === null || v === undefined || isNaN(Number(v)) || Number(v) < 0) {
          this.$message.warning(`请填写正确的${f.label}`)
          return
        }
      }
      // if (this.infoForm.platformIds == []) {
      //   this.$message.warning('请选择上架平台')
      //   return
      // }
      if (this.infoForm.isVerifyShelves == '') {
        this.$message.warning('请选择平台是否审核上架')
        return
      }
      if (this.infoForm.isShelvesAddedPlatform == 0) {
        this.$message.warning('请选择是否上架后续新增平台')
        return
      }
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          console.log(9999)
          // 组合商品不需要SKU表单验证，直接提交
          // 图片信息检查
          console.log(this.fileList)
          for (let i = 0; i < this.fileList.length; i++) {
            if (i == 0) {
              this.fileList[i].mainFlag = true
            } else {
              this.fileList[i].mainFlag = false
            }
          }
          this.infoForm.imageList = this.fileList
          if (this.infoForm.imageList.length !== 0) {
            if (this.formFiledDataState) {
              this.submitDate()
            } else {
              this.$message.warning('请完善类目属性再提交！')
            }
          } else {
            this.$message.warning('请完善图片信息再提交！')
          }
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 表单规则验证
    async verificationData1() {
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      if (infoForm.name && infoForm.name !== '') {
        const goodsId = infoForm.id || ''
        const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
        // console.log('isRepeatGoodsName', isRepeatGoodsName)
        if (isRepeatGoodsName.code !== 0) {
          // this.$message.warning('商品名称有重名，请重新输入！')
          return console.log("商品有重名")
        }
      }
      console.log(8888888888)
      if (this.fileList.length == 0) {
        this.$message.warning('请上传商品图片')
        return
      }
      if (this.infoForm.details == '') {
        this.$message.warning('请填写商品详情')
        return
      }
      if (this.skuFormConfig.attribute.length == 0) {
        this.$message.warning('请添加规格')
        return
      }
      // if (this.infoForm.platformIds == []) {
      //   this.$message.warning('请选择上架平台')
      //   return
      // }
      // if (this.infoForm.isVerifyShelves == '') {
      //   this.$message.warning('请选择平台是否审核上架')
      //   return
      // }
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          console.log(9999)
          this.$refs.skuForm.validate(valid => {
            if (valid) {
              // this.$message.success('skuForm验证通过')
              // 图片信息检查
              console.log(this.fileList)
              for (let i = 0; i < this.fileList.length; i++) {
                if (i == 0) {
                  this.fileList[i].mainFlag = true
                } else {
                  this.fileList[i].mainFlag = false
                }
              }
              this.infoForm.imageList = this.fileList
              if (this.infoForm.imageList.length !== 0) {
                if (this.formFiledDataState) {
                  this.submitDate1()
                } else {
                  this.$message.warning('请完善类目属性再提交！')
                }
              } else {
                this.$message.warning('请完善图片信息再提交！')
              }
            } else {
              // this.$message.warning('skuForm验证失败')
              return
            }
          })
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    async submitDate1() {

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      // const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      // if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表
      // 规格列表
      const skuFormConfigAttribute = this.skuFormConfig.attribute
      skuFormConfigAttribute.forEach(firstItem => {
        firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
        firstItem.itemList.forEach(secondItem => {
          secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
        })
      })

      // 合并新添加的规格值
      skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
        const inputValueArr = this.skuFormConfig.inputValueArr
        firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
        firstItem.itemList = Array.from(new Set(firstItem.itemList))
      })
      params.specList = skuFormConfigAttribute

      const tempAttribute = this.skuFormConfig.attribute
      const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
      console.log(skuFormConfigSku)
      skuFormConfigSku.forEach(item => {
        console.log(item.sku)
        item.sku = item.sku.split(';')
      })
      skuFormConfigSku.forEach((firstItem, firstIndex) => {
        const attributeLength = skuFormConfigAttribute.length
        firstItem.sort = 1
        firstItem.sku.forEach((secondItem, secondIndex) => {
          switch (attributeLength) {
            case 1:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              break
            case 2:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              break
            case 3:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.thirdGoodsSpecName = tempAttribute[2].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
              break
          }
        })
      })
      const currentPageStatus = this.currentPageStatus
      // 编辑时，给SKU添加ID   获取 缓存 数据 匹配 ID
      if (currentPageStatus === 'edit') {
        // console.log("页面状态", typeof currentPageStatus, currentPageStatus)
        // const skuFormConfigSkuLs = Array.from(new Set(JSON.parse(sessionStorage.getItem('skuFormConfigSku'))))
        // const skuFormConfigSkuls = JSON.parse(sessionStorage.getItem('skuFormConfigSku'))
        const skuFormConfigSkus = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
        skuFormConfigSku.forEach(item => {
          skuFormConfigSkuls.forEach(itemLs => {
            if (item.skuNo === itemLs.skuNo) {
              item.id = itemLs.id
            }
          })
        })
      }

      // 添加模式下 添加 skuNo 编号
      if (currentPageStatus === 'add') {
        skuFormConfigSku.forEach((item, index) => {
          item.skuNo = this.maxSkuNo
          item.skuNo = item.skuNo < 10 ? '0' + item.skuNo.toString() : item.skuNo.toString()
          this.maxSkuNo++
          item.status = 1
        })
      }

      // 复查 skuNo
      skuFormConfigSku.forEach((item, index) => {
        if (!item.relationSku) {
          item.relationSku = []
        }
        if (item.skuNo === '' || item.skuNo === undefined || item.skuNo === null) {
          // 生成sku编码
          const newSkuNo = this.maxSkuNo
          item.skuNo = newSkuNo < 10 ? '0' + newSkuNo.toString() : newSkuNo.toString()
          this.maxSkuNo++
        }
        delete item.sku
      })

      params.skuList = skuFormConfigSku
      console.log(params.skuList)
      // 图片列表 ，设置第一张图为主图
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []

      console.log(this.platforms)

      console.log(this.platforms, this.infoForm.platformIds)
      // return
      let arr = JSON.parse(JSON.stringify(this.platforms))
      arr.forEach(item => {
        this.infoForm.platformIds.forEach(itm => {
          if (item.platformId == itm) {
            Object.assign(item, { label: true })
          }
        })
      })
      arr.forEach(item => {
        if (item.label == true) {
          Object.assign(item, { status: 1 })
        } else {
          Object.assign(item, { status: 0 })
        }
      })
      console.log(arr)
      // return
      params.platformIds1 = arr

      params.status = '1'
      console.log(params)
      params.platformGoodsNo = null
      if (this.currentPageStatus === 'add') {
        // 添加
        this.$api.goodsAdd(params).then((res) => {
          if (res.code === 0) {
            // this.$message({ type: 'success', message: '添加商品成功!' })
            this.$notify({
              title: '成功',
              message: '添加商品成功!',
              type: 'success',
              duration: 3000
            })
            this.toOtherPages('goodsList')
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        // 编辑
        console.log(this.skuList, this.skuFormConfig.sku)
        let skuList = []
        this.skuFormConfig.sku.forEach(item => {
          if (!item.relationSku) {
            item.relationSku = []
          }
          if (item.skuNo == '') {
            skuList.push(item)
          }
        })
        this.addSku = skuList
        params.skuList = skuList
        // return
        delete params.attrGroupList
        delete params.categoryInfo
        delete params.goodsNo
        this.$api.goodPlatformProportions(params).then((res) => {
          if (res.code === 0) {
            console.log(res.data)
            let reMap = res.data.reMap
            let newArray = [];
            for (let key in reMap) {
              let parts = key.split('---');
              newArray.push({
                id: parts[1],
                name: parts[0],
                price: reMap[key]
              })
            }
            console.log(newArray)
            this.showPlatform = newArray
          }
        }).catch((err) => {
          console.log(err)
        })
        // if (this.time == 0) {
        //   this.time = 3; //设定间隔时间（秒）
        //   //启动计时器，倒计时time秒后自动关闭计时器。
        //   var index = setInterval(function () {
        //     this.time--;
        //     if (this.time == 0) {
        //       clearInterval(index);
        //     }
        //   }, 1000);


        // } else {
        //   this.$message.warning('已提交，无需再次提交')
        // }


      }
    },
    // 提交 数据
    async submitDate() {

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      // const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      // if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表

      // 组合商品：处理子商品列表
      const subGoodsList = this.subGoodsList.map(item => {
        return {
          originalSkuNo: item.sku || item.skuNo, // SKU编码
          quantity: Number(item.quantity) || 1, // 数量
          originalGoodsId: item.goodsId || item.id, // 原商品ID
          goodsNo: item.goodsNo, // 商品编码
          goodsName: item.goodsName, // 商品名称
          // specification: item.specification, // 规格
          status: '1', // 状态，默认上架，因为子商品列表里的状态都是1
          skuInfo: {
            id: item.id,
            marketPrice: item.marketPrice && item.marketPrice !== '' ? Number(item.marketPrice) : 0, // 市场价
            costPrice: item.costPrice && item.costPrice !== '' ? Number(item.costPrice) : 0, // 成本价
            retailPrice: item.retailPrice && item.retailPrice !== '' ? Number(item.retailPrice) : 0, // 零售价
            purchasePrice: item.purchasePrice && item.purchasePrice !== '' ? Number(item.purchasePrice) : 0, // 内购价
            settlementPrice: item.settlementPrice && item.settlementPrice !== '' ? Number(item.settlementPrice) : 0, // 结算价
            convertPrice: item.convertPrice && item.convertPrice !== '' ? Number(item.convertPrice) : 0, // 折算价
            bulkPurchasePrice: item.bulkPurchasePrice && item.bulkPurchasePrice !== '' ? Number(item.bulkPurchasePrice) : 0, // 集采价
            agentPrice: item.agentPrice && item.agentPrice !== '' ? Number(item.agentPrice) : 0, // 代理价
            stock: item.stock && item.stock !== '' ? Number(item.stock) : 0, // 虚拟库存
            status: '1', // 状态，默认上架，因为子商品列表里的状态都是1
          }
        }
      })
      params.virtualSkuList = subGoodsList // 子商品列表
      params.specList = [] // 组合商品不需要规格列表
      // 组合商品自身 SKU（价格设置表格）
      params.skuList = [{
        id: this.combinationPrice.id || undefined,
        skuNo: this.combinationPrice.skuNo || undefined,
        sku: this.combinationPrice.specification || '',
        image: this.combinationPrice.image || '',
        costPrice: this.combinationPrice.costPrice !== '' ? Number(this.combinationPrice.costPrice) : 0,
        retailPrice: this.combinationPrice.retailPrice !== '' ? Number(this.combinationPrice.retailPrice) : 0,
        purchasePrice: this.combinationPrice.purchasePrice !== '' ? Number(this.combinationPrice.purchasePrice) : 0,
        settlementPrice: this.combinationPrice.settlementPrice !== '' ? Number(this.combinationPrice.settlementPrice) : 0,
        convertPrice: this.combinationPrice.convertPrice !== '' ? Number(this.combinationPrice.convertPrice) : 0,
        bulkPurchasePrice: this.combinationPrice.bulkPurchasePrice !== '' ? Number(this.combinationPrice.bulkPurchasePrice) : 0,
        agentPrice: this.combinationPrice.agentPrice !== '' ? Number(this.combinationPrice.agentPrice) : 0,
        stock: this.combinationPrice.virtualStock !== '' ? Number(this.combinationPrice.virtualStock) : 0,
        initSellNum: this.combinationPrice.initSellNum !== '' ? Number(this.combinationPrice.initSellNum) : 0,
        weight: Number(this.combinationWeight) || 0,
        volume: Number(this.combinationVolume) || 0,
        status: this.combinationPrice.status ? '1' : '0',
      }]
      console.log('组合商品子商品列表:', subGoodsList)
      // 图片列表 ，设置第一张图为主图
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []
      // if (params.skuList.length > 0) {
      //   params.skuList.forEach(e => {
      //     if (e.status === '0') { disableSkuArrId.push(e.id) }
      //   })
      // }

      // if (disableSkuArrId.length > 0 && this.currentPageStatus === 'edit') {
      //   const giftList = await this.checkGiftListBySkuId(disableSkuArrId, 'submit')
      //   console.log('giftList', giftList)
      //   if (giftList.length > 0) {
      //     giftList.forEach(e => { tempGiftIdArr.push(e.id) })
      //   }
      // }
      /**    checkGift By sku end     **/

      /**    checkGift By Goods     **/
      // if (params.status === '0' && params.id) {
      //   const idsArr = params.id ? [params.id] : []
      //   const giftListG = await this.checkGiftListByGoodId(idsArr, 'submit')
      //   if (giftListG.length > 0) {
      //     giftListG.forEach(e => { tempGiftIdArr.push(e.id) })
      //   }
      // }
      /**    checkGift By Goods end     **/

      /**    action GiftPutOff     **/
      // const actionArr = Array.from(new Set(tempGiftIdArr))
      // // return console.log('actionArr', actionArr)
      // if (actionArr.length > 0) { await this.onGiftPutOff(actionArr) }
      /**    action GiftPutOff end     **/

      // return console.log('提交数据', params.skuList)
      // return
      // setTimeout(() => {
      //   console.log(this.platforms, this.infoForm.platformIds)
      // }, 1000)
      console.log(this.platforms)

      console.log(this.platforms, this.infoForm.platformIds)
      // return
      let arr = JSON.parse(JSON.stringify(this.platforms))
      arr.forEach(item => {
        this.infoForm.platformIds.forEach(itm => {
          if (item.platformId == itm) {
            Object.assign(item, { label: true })
          }
        })
      })
      arr.forEach(item => {
        if (item.label == true) {
          Object.assign(item, { status: 1 })
        } else {
          Object.assign(item, { status: 0 })
        }
      })
      console.log(arr)
      // return
      params.platformIds1 = arr

      // 组合商品不需要处理赠品相关逻辑
      params.status = '1'
      console.log('组合商品提交参数:', params)
      params.platformGoodsNo = null
      if (this.currentPageStatus === 'add') {
        // 添加组合商品
        if (this.time == 0) {
          this.time = 3; //设定间隔时间（秒）
          //启动计时器，倒计时time秒后自动关闭计时器。
          var index = setInterval(function () {
            this.time--;
            if (this.time == 0) {
              clearInterval(index);
            }
          }, 1000);
          this.$api.goodsCombinationAdd(params).then((res) => {
            if (res.code === 0) {
              this.$notify({
                title: '成功',
                message: '添加组合商品成功!',
                type: 'success',
                duration: 3000
              })
              this.toOtherPages('goodsList')
            } else {
              this.time = 0
              this.$message.error(res.message || '添加组合商品失败')
            }
          }).catch((err) => {
            console.log(err)
            this.time = 0
            this.$message.error('添加组合商品失败')
          })

        } else {
          this.$message.warning('已提交，无需再次提交')
          console.log('已提交，无需再次提交');
        }
      } else {
        // 编辑组合商品
        delete params.attrGroupList
        delete params.categoryInfo
        delete params.goodsNo
        params.id = this.$route.query.id
        this.$api.goodsCombinationAdd(params).then((res) => {
          if (res.code === 0) {
            this.$notify({
              title: '成功',
              message: '修改组合商品成功!',
              type: 'success',
              duration: 3000
            })
            this.toOtherPages('goodsList')
          } else {
            this.$message.error(res.message || '修改组合商品失败')
          }
        }).catch((err) => {
          console.log(err)
          this.$message.error('修改组合商品失败')
          this.initialization() // 初始化 信息
        })
      }
    },
    batchSetPrice(dataList) {
      console.log(dataList)
      if (!dataList || dataList.length === 0) {
        return
      }
      console.log("sku", this.skuFormConfig.sku)
      for (let i = 0; i < dataList.length; i++) {
        let sku = this.skuFormConfig.sku[i]
        if (!sku) {
          return
        }
        let item = dataList[i]
        this.$refs.skuForm.init()
        if (item.length >= 1) {
          this.skuFormConfig.sku[i].marketPrice = Number(item[0])
        }
        if (item.length >= 2) {
          this.skuFormConfig.sku[i].retailPrice = Number(item[1])
        }
        if (item.length >= 3) {
          this.skuFormConfig.sku[i].costPrice = Number(item[2])
        }
        if (item.length >= 4) {
          this.skuFormConfig.sku[i].purchasePrice = Number(item[3])
        }
        if (item.length >= 5) {
          this.skuFormConfig.sku[i].settlementPrice = Number(item[4])
        }
        if (item.length >= 6) {
          this.skuFormConfig.sku[i].convertPrice = Number(item[5])
        }
        if (item.length >= 7) {
          this.skuFormConfig.sku[i].bulkPurchasePrice = Number(item[6])
        }
        if (item.length >= 8) {
          this.skuFormConfig.sku[i].agentPrice = Number(item[7])
        }
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style/modifyState.scss";

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.elInput {
  display: flex;
  width: 106px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 2px;
  justify-content: space-between;
  margin-left: 16px;

  .price {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 32px;
    color: #333333;

    margin-left: 8px;
  }

  .iconI {
    // margin-left: 29px;
    margin-top: 6px;
    padding-right: 6px;
  }
}

.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

// .content{color: #333333!important;}
//删除全页面按钮边框
.el-button {
  border: none;
}

.image-text-form {
  .el-form {
    .el-form-item {
      &:first-child {
        .el-form-item__label {
          &:before {
            color: #ff0000;
            content: "*";
          }
        }
      }
    }
  }
}

.goods-category-edit {
  .edit-btn {
    background-color: #e3edff;
    color: #4168e7;
    font-size: 14px;
    text-align: center;
    width: 44px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    padding: 3px 8px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.status-box {
  font-size: 16px;
  height: 40px;
  line-height: 40px;

  .list,
  .right {
    float: left;
  }

  .list {
    width: 100px;
    text-align: center;
  }

  .right {
    padding-top: 15px;
    width: calc(100% - 100px);

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.bottom-but {
  margin-top: -20px;
  text-align: center;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button+.el-button {
    margin-left: 32px;
  }
}

.el-select {
  border-left: 1px solid #d8dce5;
  border-right: 1px solid #d8dce5;
  border-radius: 5px;
}

.attr {
  margin-top: 0;
}

.content {
  padding-bottom: 10px !important;
}

//v1.4.0新增
.labelbox {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .labelitem {
    background-color: #f0f3fd;
    padding: 2px 20px;
    font-size: 14px;
    color: #4168e7;
    position: relative;
    margin-right: 20px;
    line-height: 28px;

    .labelicon {
      color: #4168e7;
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      right: -6px;
      top: -6px;
    }
  }
}

.loglabelbox {
  padding: 20px 0;
  box-sizing: border-box;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;

  .loglabeltopbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-bottom: 1px dashed #cccccc;

    .labelitem {
      background-color: #f0f3fd;
      padding: 2px 20px;
      font-size: 14px;
      color: #4168e7;
      position: relative;
      margin-right: 20px;
      margin-bottom: 14px;
      cursor: pointer;
    }

    .labelitemc {
      .labelicon {
        color: #4168e7;
        cursor: pointer;
        position: absolute;
        font-size: 16px;
        right: -6px;
        top: -6px;
      }
    }

    .notselected {
      background-color: #4168e7;
      color: #ffffff;
    }

    .selected {
      background-color: #f3f3f3;
      color: #333333;
    }
  }

  .circlebox {
    font-size: 16px;
    color: #4168e7;
    display: flex;
    margin-top: 14px;
    align-items: center;
    margin-bottom: 14px;

    .circle {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 50%;
      background-color: #4168e7;
      color: white;
      font-size: 12px;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.circle1 {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: #4168e7;
  color: white;
  font-size: 12px;
  margin-left: 10px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 4px;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168e7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-mini {
  width: 68px;
  height: 32px;
  background: #e3edff;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168e7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}

.primary-plain {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168e7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}

// 移动端上传区域优化
.mobile-upload-wrapper {
  position: relative;
  width: 100%;

  // 移动端优化
  @media (max-width: 768px) {

    // 确保上传列表容器正常显示
    :deep(.el-upload-list) {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
    }

    // 优化图片项在移动端的显示，确保不重叠
    :deep(.itemI) {
      // width: calc(50% - 5px) !important;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    // 上传按钮区域优化 - 确保始终可见
    :deep(.el-upload) {
      // width: calc(50% - 5px) !important;
      min-width: auto;
      margin: 0 10px 10px 0;
      position: relative;
      z-index: 10;
      display: block !important; // 确保显示
      visibility: visible !important; // 确保可见
      opacity: 1 !important; // 确保不透明

      // 确保上传按钮在图片之后显示
      &:nth-child(2n) {
        margin-right: 0;
      }

      // 关键：确保上传按钮始终可见且可点击
      .el-upload--picture-card {
        width: 100%;
        height: 146px;
        line-height: 146px;
        position: relative;
        z-index: 1;
        // display: flex !important;
        // visibility: visible !important;
        // opacity: 1 !important;
        // 优化触摸反馈
        -webkit-tap-highlight-color: rgba(64, 104, 231, 0.2);
        touch-action: manipulation;
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        pointer-events: auto !important;
        background-color: #fbfdff; // 确保背景色可见
        border: 1px dashed #c0ccda; // 确保边框可见
      }

      // 关键：确保input元素在移动端可以点击
      input[type="file"] {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: 2;
        cursor: pointer;
        pointer-events: auto !important;
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
        display: block !important;
      }

      // 上传按钮图标区域
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        pointer-events: none;
        z-index: 1;
        position: relative;
        display: block !important;
      }
    }

    // 确保即使有图片时上传按钮也显示（若需要强制显示，可在此补充样式）
  }
}

.btnBox {
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  margin: 0 -10px;

  /deep/ {
    .el-input--small .el-input__icon {
      line-height: 25px;
    }

    .el-form-item__content {

      line-height: 1;
    }

    .el-input-group__prepend {
      width: 90px;
      padding: 0 12px 0 10px;
      box-sizing: border-box;

      // font-family: PingFang SC;
      // font-weight: 400;
      .el-input__inner {
        padding: 0 10px 0 7px;
        text-align: left;
      }
    }

    .el-input__inner {
      padding: 0 8px 0;
      height: 24px;
      line-height: 24px;
      border-radius: 0;
      width: 92px;

    }

    .group-con-form {

      .el-input--mini,
      .el-cascader--mini {
        width: 180px;
      }

      .el-input__inner {
        text-align: left;
        padding: 0 10px 0 8px;
        max-width: 180px;
      }
    }
  }
}

.input-with-select {
  display: flex;
  align-items: center;

  .prepend-text {
    width: 84px;
    flex-shrink: 0;
    background-color: #F5F7FA;
    border: 1px solid #DCDFE6;
    border-right: none;
    font-size: 12px;
    color: #909399;
    font-family: Arial;
    height: 24px;
    line-height: 22px;
    box-sizing: border-box;
    padding: 0 0 0 6px;
  }

  .select {
    border-radius: 0;
    line-height: 24px;


    .el-input__inner {
      border-radius: 0;
      padding: 0 8px 0 0;
      font-size: 12px;
      font-family: Arial;
      height: 24px !important;
    }

    .el-input__suffix {
      display: none;
    }

    .el-cascader__tags {
      flex-wrap: nowrap;
      cursor: pointer;
      justify-content: flex-end;
      right: 3px;

      .el-tag {
        margin: 0;
        padding: 0 1px;
        height: 18px;
        max-width: calc(100% - 3px);
        // background-color: #fff;
      }

      .el-tag__close {
        display: none;
      }
    }
  }

  // .select-one .el-cascader__tags{

  // }
  .select-two .el-cascader__tags {
    .el-tag {
      max-width: calc(100% - 25px);
      // margin-right: 2px;
    }

    .el-tag:last-child {
      // letter-spacing: -1px;
      margin-left: 2px;

      & span::first-letter {
        margin-right: -2px;
      }
    }
  }

  .select-ten .el-cascader__tags {
    .el-tag {
      max-width: calc(100% - 32px);
    }
  }
}
</style>